import React, { useEffect, useState, useMemo, useCallback, useRef } from "react"
import { Table, Spinner, Modal, ModalHeader, ModalBody } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"

const TAB = { PURCHASES: 1, IMPORTS: 2, DELETED: 3 }

const VlccPurchases = () => {
  const { canAdd, canEdit, canDelete, canExport, MODULE } = usePermissions()
  const MID = MODULE.VLCC_PURCHASES

  const [tab, setTab] = useState(TAB.PURCHASES)
  const [data, setData]           = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [search, setSearch]       = useState("")
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [page, setPage]           = useState(1)
  const perPage = 50

  // Alerts
  const [confirmAlert, setConfirmAlert]   = useState(false)
  const [confirmMulti, setConfirmMulti]   = useState(false)
  const [successDlg, setSuccessDlg]       = useState(false)
  const [dlgTitle, setDlgTitle]           = useState("")
  const [dlgDesc, setDlgDesc]             = useState("")
  const [deleteId, setDeleteId]           = useState(null)

  // Companies
  const [companies, setCompanies] = useState([])

  // Tab 1 filters
  const [fDateFrom, setFDateFrom]   = useState("")
  const [fDateTo, setFDateTo]       = useState("")
  const [fShift, setFShift]         = useState("")
  const [fMilk, setFMilk]           = useState("")
  const [fCC, setFCC]               = useState("")
  const [fProducer, setFProducer]   = useState("")
  const clearFilters = () => { setFDateFrom(""); setFDateTo(""); setFShift(""); setFMilk(""); setFCC(""); setFProducer("") }

  // â”€â”€ Import Modal state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [importOpen, setImportOpen]     = useState(false)
  const [importType, setImportType]     = useState("single_shift")
  const [iCompany, setICompany]         = useState("")
  const [iPlant, setIPlant]             = useState("")
  const [iCC, setICC]                   = useState("")
  const [iRoute, setIRoute]             = useState("")
  const [iCenter, setICenter]           = useState("")
  const [iDate, setIDate]               = useState("")
  const [iShift, setIShift]             = useState("0")
  const [iFile, setIFile]               = useState(null)
  const [iPlants, setIPlants]           = useState([])
  const [iCCs, setICCs]                 = useState([])
  const [iRoutes, setIRoutes]           = useState([])
  const [iCenters, setICenters]         = useState([])
  const [importing, setImporting]       = useState(false)
  const [importResult, setImportResult] = useState(null)
  const fileRef = useRef(null)

  const resetImport = () => {
    setImportType("single_shift"); setICompany(""); setIPlant(""); setICC(""); setIRoute(""); setICenter("")
    setIDate(""); setIShift("0"); setIFile(null); setImportResult(null)
    setIPlants([]); setICCs([]); setIRoutes([]); setICenters([])
    if (fileRef.current) fileRef.current.value = ""
  }
  const openImport = () => {
    resetImport()
    // Load companies first; if only 1, load all plants immediately
    api.get("companies").then(r => {
      const cos = r?.data?.data; const list = Array.isArray(cos) ? cos : cos?.data || []
      setCompanies(list)
      if (list.length <= 1) {
        // Single company â€” load all plants directly
        api.get("plants").then(rp => { const d = rp?.data?.data; setIPlants(Array.isArray(d) ? d : d?.data || []) }).catch(() => {})
      }
    }).catch(() => {
      api.get("plants").then(rp => { const d = rp?.data?.data; setIPlants(Array.isArray(d) ? d : d?.data || []) }).catch(() => {})
    })
    setImportOpen(true)
  }
  const onICompany = async v => {
    setICompany(v); setIPlant(""); setICC(""); setIRoute(""); setICenter("")
    setIPlants([]); setICCs([]); setIRoutes([]); setICenters([])
    if (v) {
      try { const r = await api.get("plants-by-company/" + v); const d = r?.data?.data; setIPlants(Array.isArray(d) ? d : d?.data || []) } catch(e){}
    } else {
      // No company selected â€” load all plants
      try { const r = await api.get("plants"); const d = r?.data?.data; setIPlants(Array.isArray(d) ? d : d?.data || []) } catch(e){}
    }
  }
  const onIPlant = async v => { setIPlant(v); setICC(""); setIRoute(""); setICenter(""); setICCs([]); setIRoutes([]); setICenters([]); if (v) { try { const r = await api.get("chillings-by-plant/" + v); const d = r?.data?.data; setICCs(Array.isArray(d) ? d : d?.data || []) } catch(e){} } }
  const onICC = async v => { setICC(v); setIRoute(""); setICenter(""); setIRoutes([]); setICenters([]); if (v) { try { const r = await api.get("route-cc/" + v); const d = r?.data?.data; setIRoutes(Array.isArray(d) ? d : d?.data || []) } catch(e){} } }
  const onIRoute = async v => { setIRoute(v); setICenter(""); setICenters([]); if (v) { try { const r = await api.get("collection-center-route/" + v); const d = r?.data?.data; setICenters(Array.isArray(d) ? d : d?.data || []) } catch(e){} } }

  const downloadTemplate = () => {
    const templates = {
      single_shift:    "Serial No,Producer Num,Milk Type,Quantity,FAT,SNF,Water %,Rate",
      multiple_shift:  "Date(dd-mm-yyyy),Shift,Serial No,Producer Num,Milk Type,Quantity,FAT,SNF,Water %,Rate",
      multiple_centers:"Route No,Center No,Date(dd-mm-yyyy),Shift,Serial No,Producer Num,Milk Type,Quantity,FAT,SNF,Water %,Rate",
    }
    const csv = templates[importType] + "\n"
    const b = new Blob([csv], { type: "text/csv" })
    const l = document.createElement("a"); l.href = URL.createObjectURL(b)
    l.download = `vlcc_import_template_${importType}.csv`; l.click()
  }

  const handleImport = async () => {
    if (!iPlant) return alert("Plant is required.")
    if (!iCC && importType !== "multiple_centers") return alert("Chilling Center is required.")
    if ((importType === "single_shift" || importType === "multiple_shift") && !iRoute) return alert("Route is required.")
    if ((importType === "single_shift" || importType === "multiple_shift") && !iCenter) return alert("Center is required.")
    if (importType === "single_shift" && !iDate) return alert("Date is required.")
    if (!iFile) return alert("Please choose a CSV file.")
    setImporting(true); setImportResult(null)
    const fd = new FormData()
    fd.append("import_type", importType)
    fd.append("plant", iPlant)
    fd.append("chilling_center", iCC || "")
    if (iRoute)  fd.append("route", iRoute)
    if (iCenter) fd.append("collection_center", iCenter)
    if (importType === "single_shift") { fd.append("import_date", iDate); fd.append("shift", iShift) }
    fd.append("file", iFile)
    try {
      const r = await api.post("vlcc-purchase-import", fd, { headers: { "Content-Type": "multipart/form-data" } })
      setImportResult({ success: r.data.success, message: r.data.data, imported: r.data.imported, failed: r.data.failed, errors: r.data.errors || [] })
      if (r.data.success) { fetchData() }
    } catch(e) {
      const msg = e.response?.data?.data || e.response?.data?.message || "Import failed."
      setImportResult({ success: false, message: msg, imported: 0, failed: 0, errors: [] })
    }
    setImporting(false)
  }

  // â”€â”€ Purchase Update Modal state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [updateOpen, setUpdateOpen]         = useState(false)
  // cascade
  const [uCompany, setUCompany]             = useState("")
  const [uPlant, setUPlant]                 = useState("")
  const [uCC, setUCC]                       = useState("")
  const [uRoute, setURoute]                 = useState("")
  const [uCollection, setUCollection]       = useState("")
  const [uProducer, setUProducer]           = useState("")
  const [uPlants, setUPlants]               = useState([])
  const [uCCs, setUCCs]                     = useState([])
  const [uRoutes, setURoutes]               = useState([])
  const [uCollections, setUCollections]     = useState([])
  const [uProducers, setUProducers]         = useState([])
  // params
  const [uDisplay, setUDisplay]             = useState("single")
  const [uDate, setUDate]                   = useState("")
  const [uShift, setUShift]                 = useState("")
  const [uPeriodFrom, setUPeriodFrom]       = useState("")
  const [uPeriodTo, setUPeriodTo]           = useState("")
  const [uMilkType, setUMilkType]           = useState("0")
  const [uEntryMode, setUEntryMode]         = useState("SNF")
  const [uUseCustomRate, setUUseCustomRate] = useState("No")
  const [uRateCharts, setURateCharts]       = useState([])
  const [uRateChartId, setURateChartId]     = useState("")
  const [uApplyIncentive, setUApplyIncentive]       = useState("no")
  const [uIncentiveCharts, setUIncentiveCharts]     = useState([])
  const [uIncentiveChartId, setUIncentiveChartId]   = useState("")
  const [uFlatIncentive, setUFlatIncentive]         = useState("")
  // preview & save
  const [previewRows, setPreviewRows]           = useState([])
  const [originalPreviewRows, setOriginalPreviewRows] = useState([])
  const [previewTotal, setPreviewTotal]         = useState(0)
  const [previewLoading, setPreviewLoading]     = useState(false)
  const [updateSaving, setUpdateSaving]         = useState(false)
  const [updateResult, setUpdateResult]         = useState(null)

  // â”€â”€ Manipulate Values panel â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [uOvAction, setUOvAction]         = useState("increase")  // increase | decrease
  const [uOvField, setUOvField]           = useState("qty")        // qty | fat | snf | clr | rate
  const [uOvBy, setUOvBy]                 = useState("")
  const [uOvCondField, setUOvCondField]   = useState("qty")        // conditional field
  const [uOvCondMin, setUOvCondMin]       = useState("")
  const [uOvCondMax, setUOvCondMax]       = useState("")

  const resetUpdate = () => {
    setUCompany(""); setUPlant(""); setUCC(""); setURoute(""); setUCollection(""); setUProducer("")
    setUPlants([]); setUCCs([]); setURoutes([]); setUCollections([]); setUProducers([])
    setUDisplay("single"); setUDate(""); setUShift(""); setUPeriodFrom(""); setUPeriodTo("")
    setUMilkType("0"); setUEntryMode("SNF"); setUUseCustomRate("No")
    setURateCharts([]); setURateChartId("")
    setUApplyIncentive("no"); setUIncentiveChartId(""); setUFlatIncentive("")
    setPreviewRows([]); setOriginalPreviewRows([]); setPreviewTotal(0); setUpdateResult(null)
    setUOvAction("increase"); setUOvField("qty"); setUOvBy(""); setUOvCondField("qty"); setUOvCondMin(""); setUOvCondMax("")
  }

  const openUpdateModal = () => {
    resetUpdate()
    // load incentive charts + companies/plants on open
    api.get("active-incentive-charts").then(r => setUIncentiveCharts(arr(r))).catch(() => {})
    api.get("companies").then(r => {
      const list = arr(r); setCompanies(list)
      if (list.length <= 1) {
        api.get("plants").then(rp => setUPlants(arr(rp))).catch(() => {})
      }
    }).catch(() => {
      api.get("plants").then(rp => setUPlants(arr(rp))).catch(() => {})
    })
    setUpdateOpen(true)
  }

  const onUCompany = async v => {
    setUCompany(v); setUPlant(""); setUCC(""); setURoute(""); setUCollection(""); setUProducer("")
    setUPlants([]); setUCCs([]); setURoutes([]); setUCollections([]); setUProducers([])
    setPreviewRows([]); setUpdateResult(null)
    try {
      const r = v ? await api.get("plants-by-company/" + v) : await api.get("plants")
      setUPlants(arr(r))
    } catch(e) {}
  }
  const onUPlant = async v => {
    setUPlant(v); setUCC(""); setURoute(""); setUCollection(""); setUProducer("")
    setUCCs([]); setURoutes([]); setUCollections([]); setUProducers([])
    setPreviewRows([]); setUpdateResult(null)
    if (v) try { setUCCs(arr(await api.get("chillings-by-plant/" + v))) } catch(e) {}
  }
  const onUCC = async v => {
    setUCC(v); setURoute(""); setUCollection(""); setUProducer("")
    setURoutes([]); setUCollections([]); setUProducers([])
    setPreviewRows([]); setUpdateResult(null)
    if (v) try { setURoutes(arr(await api.get("route-cc/" + v))) } catch(e) {}
  }
  const onURoute = async v => {
    setURoute(v); setUCollection(""); setUProducer("")
    setUCollections([]); setUProducers([])
    setPreviewRows([]); setUpdateResult(null)
    if (v) try { setUCollections(arr(await api.get("collection-center-route/" + v))) } catch(e) {}
  }
  const onUCollection = async v => {
    setUCollection(v); setUProducer(""); setUProducers([])
    setPreviewRows([]); setUpdateResult(null)
    if (v) try { setUProducers(arr(await api.get("producer-center/" + v))) } catch(e) {}
  }
  const onUMilkType = async v => {
    setUMilkType(v); setURateChartId(""); setPreviewRows([]); setUpdateResult(null)
    if (uUseCustomRate === "Yes") {
      const typeMap = { "0": 3, "1": 1, "2": 2 }
      try { setURateCharts(arr(await api.get("rate-chart-type/" + (typeMap[v] || 3)))) } catch(e) {}
    }
  }
  const onUUseCustomRate = async v => {
    setUUseCustomRate(v); setURateChartId(""); setPreviewRows([]); setUpdateResult(null)
    if (v === "Yes") {
      const typeMap = { "0": 3, "1": 1, "2": 2 }
      try { setURateCharts(arr(await api.get("rate-chart-type/" + (typeMap[uMilkType] || 3)))) } catch(e) {}
    } else { setURateCharts([]) }
  }

  const chartLabel = uMilkType === "1" ? "Custom Cow Milk Chart"
                   : uMilkType === "2" ? "Custom Buffalo Milk Chart"
                   : "Custom Common Milk Chart"

  const buildUpdatePayload = () => ({
    collectionCenter: uCollection,
    producer: uProducer || "",
    displayMode: uDisplay,
    date: uDate,
    shift: uShift,
    periodFrom: uPeriodFrom,
    periodTo: uPeriodTo,
    milkType: uMilkType,
    entryMode: uEntryMode,
    useCustomRate: uUseCustomRate,
    customRateChartId: uRateChartId || "",
    applyIncentive: uApplyIncentive,
    incentiveChartId: uIncentiveChartId || "",
    flatIncentivePerLtr: uFlatIncentive || "0",
  })

  const handlePreview = async () => {
    if (!uCollection) return alert("Collection Center is required.")
    if (uDisplay === "single" && !uDate) return alert("Date is required.")
    if (uDisplay === "period" && (!uPeriodFrom || !uPeriodTo)) return alert("Period From and Period To are required.")
    if (uUseCustomRate === "Yes" && !uRateChartId) return alert("Please select a Custom Rate Chart.")
    if (uApplyIncentive === "chart" && !uIncentiveChartId) return alert("Please select a Custom Incentive Chart.")
    if (uApplyIncentive === "flat" && !(parseFloat(uFlatIncentive) > 0)) return alert("Flat Incentive per Liter/KG must be > 0.")
    setPreviewLoading(true); setPreviewRows([]); setOriginalPreviewRows([]); setUpdateResult(null)
    try {
      const r = await api.post("vlcc-purchase-update-preview", buildUpdatePayload())
      const rows = r.data.data || []
      setPreviewRows(rows)
      setOriginalPreviewRows(rows)
      setPreviewTotal(r.data.totalCount || 0)
    } catch(e) {
      alert(e.response?.data?.data || "Preview failed.")
    }
    setPreviewLoading(false)
  }

  // â”€â”€ Manipulate Values: apply overrides client-side to preview rows â”€â”€â”€â”€â”€â”€â”€â”€
  const applyManipulate = () => {
    const by = parseFloat(uOvBy)
    if (isNaN(by) || by === 0) return alert("Please enter a non-zero value in the 'By' field.")
    const condMin = uOvCondMin !== "" ? parseFloat(uOvCondMin) : null
    const condMax = uOvCondMax !== "" ? parseFloat(uOvCondMax) : null
    const dir = uOvAction === "decrease" ? -1 : 1  // Increase = +, Decrease = âˆ’

    const getCondVal = r => {
      switch (uOvCondField) {
        case "fat":  return parseFloat(r.purchaseFat  || 0)
        case "snf":  return parseFloat(r.purchaseSnf  || 0)
        case "clr":  return parseFloat(r.purchaseClr  || 0)
        case "rate": return parseFloat(r.newRatePerLtr || 0)
        default:     return parseFloat(r.qtyLtrs || 0)
      }
    }

    setPreviewRows(prev => prev.map(r => {
      const condVal = getCondVal(r)
      const inRange =
        (condMin === null || condVal >= condMin) &&
        (condMax === null || condVal <= condMax)
      if (!inRange) return r

      let fat  = parseFloat(r.purchaseFat  || 0)
      let snf  = parseFloat(r.purchaseSnf  || 0)
      let clr  = parseFloat(r.purchaseClr  || 0)
      let qty  = parseFloat(r.qtyLtrs      || 0)
      let rate = parseFloat(r.newRatePerLtr || 0)

      if (uOvField === "qty")  qty  = Math.max(0, parseFloat((qty  + dir * by).toFixed(3)))
      if (uOvField === "fat")  fat  = Math.max(0, parseFloat((fat  + dir * by).toFixed(2)))
      if (uOvField === "snf")  snf  = Math.max(0, parseFloat((snf  + dir * by).toFixed(2)))
      if (uOvField === "clr")  clr  = Math.max(0, parseFloat((clr  + dir * by).toFixed(2)))
      if (uOvField === "rate") rate = Math.max(0, parseFloat((rate + dir * by).toFixed(2)))

      const inc      = parseFloat(r.newIncentive || 0)
      const newTotal = parseFloat((rate * qty + inc).toFixed(2))
      return { ...r, qtyLtrs: qty, purchaseFat: fat, purchaseSnf: snf, purchaseClr: clr, newRatePerLtr: rate, newTotal }
    }))
  }

  // â”€â”€ Old Summary: reads original DB values (oldRatePerLtr, oldIncentive from server) â”€â”€
  const oldSummary = (rows) => {
    if (!rows.length) return { qty: "0", fat: "0", snf: "0", rate: "0", amount: "0" }
    const n      = rows.length
    const qty    = rows.reduce((s, r) => s + parseFloat(r.qtyLtrs     || 0), 0)
    const fat    = rows.reduce((s, r) => s + parseFloat(r.purchaseFat  || 0), 0)
    const snf    = rows.reduce((s, r) => s + parseFloat(r.purchaseSnf  || r.purchaseClr || 0), 0)
    const rate   = rows.reduce((s, r) => s + parseFloat(r.oldRatePerLtr || 0), 0)  // â† true DB rate
    const amount = rows.reduce((s, r) =>
      s + parseFloat(r.oldRatePerLtr || 0) * parseFloat(r.qtyLtrs || 0) + parseFloat(r.oldIncentive || 0), 0)
    return {
      qty: qty.toFixed(3), fat: n ? (fat / n).toFixed(2) : "0",
      snf: n ? (snf / n).toFixed(2) : "0",  rate: n ? (rate / n).toFixed(2) : "0",
      amount: amount.toFixed(2),
    }
  }

  // â”€â”€ New Summary: reads current (possibly manipulated) state â”€â”€
  const newSummary = (rows) => {
    if (!rows.length) return { qty: "0", fat: "0", snf: "0", rate: "0", amount: "0" }
    const n      = rows.length
    const qty    = rows.reduce((s, r) => s + parseFloat(r.qtyLtrs      || 0), 0)
    const fat    = rows.reduce((s, r) => s + parseFloat(r.purchaseFat   || 0), 0)
    const snf    = rows.reduce((s, r) => s + parseFloat(r.purchaseSnf   || r.purchaseClr || 0), 0)
    const rate   = rows.reduce((s, r) => s + parseFloat(r.newRatePerLtr || 0), 0)  // â† chart/manipulated rate
    const amount = rows.reduce((s, r) => s + parseFloat(r.newTotal      || 0), 0)
    return {
      qty: qty.toFixed(3), fat: n ? (fat / n).toFixed(2) : "0",
      snf: n ? (snf / n).toFixed(2) : "0",  rate: n ? (rate / n).toFixed(2) : "0",
      amount: amount.toFixed(2),
    }
  }

  const handleBulkUpdate = async () => {
    if (!previewRows.length) return
    if (!window.confirm(`This will update ${previewTotal} purchase record(s). Proceed?`)) return
    setUpdateSaving(true); setUpdateResult(null)
    try {
      // Check if user applied any manual manipulations
      const hasManipulations = previewRows.some((r, i) => {
        const o = originalPreviewRows[i]
        if (!o) return false
        return (
          parseFloat(r.qtyLtrs)       !== parseFloat(o.qtyLtrs)       ||
          parseFloat(r.purchaseFat)   !== parseFloat(o.purchaseFat)   ||
          parseFloat(r.purchaseSnf)   !== parseFloat(o.purchaseSnf)   ||
          parseFloat(r.purchaseClr)   !== parseFloat(o.purchaseClr)   ||
          parseFloat(r.newRatePerLtr) !== parseFloat(o.newRatePerLtr)
        )
      })

      let payload
      if (hasManipulations) {
        // Send per-row overrides
        payload = {
          manualOverrides: previewRows.map(r => ({
            id:         r.id,
            fat:        r.purchaseFat,
            snf:        r.purchaseSnf,
            clr:        r.purchaseClr,
            qtyLtrs:    r.qtyLtrs,
            ratePerLtr: r.newRatePerLtr,
            incentive:  r.newIncentive,
          }))
        }
      } else {
        payload = buildUpdatePayload()
      }

      const r = await api.post("bulk-update-vlcc-purchases", payload)
      setUpdateResult({ success: r.data.success, message: r.data.data, updated: r.data.updated, failed: r.data.failed, errors: r.data.errors || [] })
      if (r.data.success) { fetchData(); setPreviewRows([]); setOriginalPreviewRows([]) }
    } catch(e) {
      setUpdateResult({ success: false, message: e.response?.data?.data || "Update failed.", updated: 0, failed: 0, errors: [] })
    }
    setUpdateSaving(false)
  }

  // ── Summary helpers for Update modal ────────────────────────────────────
  const uOldSummary = rows => {
    const n = rows.length || 1
    const qty = rows.reduce((s, r) => s + parseFloat(r.qtyLtrs || 0), 0)
    const fat = rows.reduce((s, r) => s + parseFloat(r.purchaseFat || 0), 0) / n
    const snf = rows.reduce((s, r) => s + parseFloat(r.purchaseSnf || 0), 0) / n
    const rate = rows.reduce((s, r) => s + parseFloat(r.oldRatePerLtr || 0), 0) / n
    const amount = rows.reduce((s, r) => s + parseFloat(r.oldRatePerLtr || 0) * parseFloat(r.qtyLtrs || 0) + parseFloat(r.oldIncentive || 0), 0)
    return { qty: qty.toFixed(2), fat: fat.toFixed(2), snf: snf.toFixed(2), rate: rate.toFixed(2), amount: amount.toFixed(2) }
  }
  const uNewSummary = rows => {
    const n = rows.length || 1
    const qty = rows.reduce((s, r) => s + parseFloat(r.qtyLtrs || 0), 0)
    const fat = rows.reduce((s, r) => s + parseFloat(r.purchaseFat || 0), 0) / n
    const snf = rows.reduce((s, r) => s + parseFloat(r.purchaseSnf || 0), 0) / n
    const rate = rows.reduce((s, r) => s + parseFloat(r.newRatePerLtr || 0), 0) / n
    const amount = rows.reduce((s, r) => s + parseFloat(r.newTotal || 0), 0)
    return { qty: qty.toFixed(2), fat: fat.toFixed(2), snf: snf.toFixed(2), rate: rate.toFixed(2), amount: amount.toFixed(2) }
  }

  // ── Purchase Bulk Add Modal ─────────────────────────────────────────────
  const [baOpen, setBaOpen] = useState(false)
  const [baCompany, setBaCompany] = useState("")
  const [baPlant, setBaPlant] = useState("")
  const [baCC, setBaCC] = useState("")
  const [baRoute, setBaRoute] = useState("")
  const [baCollection, setBaCollection] = useState("")
  const [baDate, setBaDate] = useState("")
  const [baShift, setBaShift] = useState("0")
  const [baMode, setBaMode] = useState("SNF")
  const [baUseShortNum, setBaUseShortNum] = useState("Yes")
  const [baPlants, setBaPlants] = useState([])
  const [baCCs, setBaCCs] = useState([])
  const [baRoutes, setBaRoutes] = useState([])
  const [baCollections, setBaCollections] = useState([])
  const [baShowTable, setBaShowTable] = useState(false)
  const [baSaving, setBaSaving] = useState(false)
  const [baCompanySettings, setBaCompanySettings] = useState(null)
  const [baRateAvail, setBaRateAvail] = useState(null)
  const defaultBaRow = () => ({
    producerNum: "", producerName: "", producerId: null, lookupState: "",
    milkType: "3", qty: "", purchaseFat: "", purchaseSnf: "", purchaseClr: "",
    qtyKg: "", ratePerLtr: "", rateLookupState: ""
  })
  const [baRows, setBaRows] = useState([defaultBaRow()])

  const resetBa = () => {
    setBaCompany(""); setBaPlant(""); setBaCC(""); setBaRoute(""); setBaCollection("")
    setBaDate(""); setBaShift("0"); setBaMode("SNF"); setBaUseShortNum("Yes")
    setBaPlants([]); setBaCCs([]); setBaRoutes([]); setBaCollections([])
    setBaShowTable(false); setBaSaving(false); setBaCompanySettings(null); setBaRateAvail(null)
    setBaRows([defaultBaRow()])
  }
  const openBa = () => {
    resetBa()
    api.get("companies").then(r => {
      const list = arr(r); setCompanies(list)
      if (list.length === 1) {
        setBaCompany(String(list[0].id))
        api.get("plants-by-company/" + list[0].id).then(r2 => setBaPlants(arr(r2))).catch(() => {
          api.get("plants").then(r3 => setBaPlants(arr(r3))).catch(() => {})
        })
      }
    }).catch(() => { api.get("plants").then(r2 => setBaPlants(arr(r2))).catch(() => {}) })
    setBaOpen(true)
  }
  const onBaCompany = async v => {
    setBaCompany(v); setBaPlant(""); setBaCC(""); setBaRoute(""); setBaCollection("")
    setBaPlants([]); setBaCCs([]); setBaRoutes([]); setBaCollections([]); setBaShowTable(false)
    setBaCompanySettings(null); setBaRateAvail(null)
    if (v) try { setBaPlants(arr(await api.get("plants-by-company/" + v))) } catch(e) {
      try { setBaPlants(arr(await api.get("plants"))) } catch(e2) {}
    }
  }
  const onBaPlant = async v => {
    setBaPlant(v); setBaCC(""); setBaRoute(""); setBaCollection("")
    setBaCCs([]); setBaRoutes([]); setBaCollections([]); setBaShowTable(false)
    setBaCompanySettings(null); setBaRateAvail(null)
    if (v) try { setBaCCs(arr(await api.get("chillings-by-plant/" + v))) } catch(e) {}
  }
  const onBaCC = async v => {
    setBaCC(v); setBaRoute(""); setBaCollection("")
    setBaRoutes([]); setBaCollections([]); setBaShowTable(false)
    setBaCompanySettings(null); setBaRateAvail(null)
    if (v) try { setBaRoutes(arr(await api.get("route-cc/" + v))) } catch(e) {}
  }
  const onBaRoute = async v => {
    setBaRoute(v); setBaCollection(""); setBaCollections([]); setBaShowTable(false)
    setBaRateAvail(null)
    if (v) try { setBaCollections(arr(await api.get("collection-center-route/" + v))) } catch(e) {}
  }
  const onBaCollection = async v => {
    setBaCollection(v); setBaShowTable(false); setBaCompanySettings(null); setBaRateAvail(null)
    if (v) {
      try {
        const ccList = baCCs.length ? baCCs : arr(await api.get("chillings-by-plant/" + baPlant))
        const cc = ccList.find(c => String(c.id) === String(baCC))
        if (cc && cc.plant_id) {
          const plant = baPlants.find(p => String(p.id) === String(cc.plant_id)) || (baPlant ? { id: baPlant, company_id: "" } : null)
          const companyId = plant?.company_id || baCompany || (companies.length === 1 ? companies[0].id : "")
          if (companyId) {
            const sr = await api.get("settings-by-company/" + companyId)
            setBaCompanySettings(sr.data?.data || sr.data || null)
          }
        }
      } catch(e) {}
      try {
        await api.post("lookup-rate", { collectionCenter: parseInt(v), milkType: 3, fat: 4, snf: 8 })
        setBaRateAvail(true)
      } catch(e) { setBaRateAvail(false) }
    }
  }

  const lookupProducer = async (rowIdx, num) => {
    if (!num || !baCollection) return
    setBaRows(prev => prev.map((row, i) => i === rowIdx ? { ...row, lookupState: "loading" } : row))
    try {
      const r = await api.get(`lookup-producer-by-number?number=${encodeURIComponent(num)}&collectionCenter=${baCollection}`)
      if (r.data.success) {
        const p = r.data.data
        setBaRows(prev => prev.map((row, i) => i === rowIdx
          ? { ...row, producerName: p.producerName || p.name, producerId: p.id, milkType: String(p.milkType || 3), lookupState: "ok" } : row))
      } else {
        setBaRows(prev => prev.map((row, i) => i === rowIdx
          ? { ...row, producerName: "NOT FOUND", producerId: null, lookupState: "err" } : row))
      }
    } catch(e) {
      setBaRows(prev => prev.map((row, i) => i === rowIdx
        ? { ...row, producerName: "NOT FOUND", producerId: null, lookupState: "err" } : row))
    }
  }

  const setBaRowField = (i, field, val) => setBaRows(r => r.map((row, idx) => {
    if (idx !== i) return row
    const updated = { ...row, [field]: val }
    const fat = parseFloat(field === "purchaseFat" ? val : updated.purchaseFat) || 0
    const formula = baCompanySettings?.snf_clr_formula || "Tamil Nadu"
    if (formula.includes("Tamil Nadu") || formula.includes("CLR/4")) {
      if (baMode === "SNF" && (field === "purchaseSnf" || field === "purchaseFat")) {
        const snf = parseFloat(field === "purchaseSnf" ? val : updated.purchaseSnf) || 0
        if (snf > 0 && fat > 0) updated.purchaseClr = Math.max(0, (snf - 0.2 * fat - 0.36) * 4).toFixed(2)
      } else if (baMode === "CLR" && (field === "purchaseClr" || field === "purchaseFat")) {
        const clr = parseFloat(field === "purchaseClr" ? val : updated.purchaseClr) || 0
        if (clr > 0 && fat > 0) updated.purchaseSnf = (clr / 4 + 0.2 * fat + 0.36).toFixed(2)
      }
    }
    if (field === "qty" || field === "milkType") {
      const qtyLtrs = parseFloat(field === "qty" ? val : updated.qty) || 0
      const mType = field === "milkType" ? val : updated.milkType
      const factor = mType === "2"
        ? parseFloat(baCompanySettings?.liter_to_kg_buffalo || 1.03)
        : parseFloat(baCompanySettings?.liter_to_kg_cow || 1.03)
      if (qtyLtrs > 0) updated.qtyKg = (qtyLtrs * factor).toFixed(3)
    }
    const snfVal = parseFloat(updated.purchaseSnf) || 0
    const clrVal = parseFloat(updated.purchaseClr) || 0
    const fatVal = parseFloat(updated.purchaseFat) || 0
    if (fatVal > 0 && (snfVal > 0 || clrVal > 0) && baCollection &&
        (field === "purchaseFat" || field === "purchaseSnf" || field === "purchaseClr" || field === "milkType")) {
      api.post("lookup-rate", { collectionCenter: parseInt(baCollection), milkType: parseInt(updated.milkType || 3), fat: fatVal, snf: snfVal || clrVal })
        .then(r2 => {
          if (r2.data.success) setBaRows(prev => prev.map((rw, j) => j === i ? { ...rw, ratePerLtr: r2.data.data.ratePerLtr, rateLookupState: "ok" } : rw))
        }).catch(() => {
          setBaRows(prev => prev.map((rw, j) => j === i ? { ...rw, ratePerLtr: "", rateLookupState: "err" } : rw))
        })
    }
    return updated
  }))

  const handleBaSave = async () => {
    if (!baCC || !baRoute || !baCollection || !baDate) return alert("Fill all required fields.")
    const validRows = baRows.filter(r => r.producerId && parseFloat(r.qty) > 0 && parseFloat(r.purchaseFat) > 0)
    if (!validRows.length) return alert("No valid rows to save. Each row needs Producer, Qty, and FAT.")
    setBaSaving(true)
    try {
      const r = await api.post("bulk-create-vlcc-purchases", {
        chillingCenter: parseInt(baCC), route: parseInt(baRoute), collectionCenter: parseInt(baCollection),
        purchaseDate: baDate, shift: parseInt(baShift), entryMode: baMode, useShortNum: baUseShortNum,
        rows: validRows.map(row => ({
          producerId: row.producerId, producerNum: row.producerNum,
          milkType: row.milkType, qtyLtrs: row.qty,
          purchaseFat: row.purchaseFat, purchaseSnf: row.purchaseSnf || "",
          purchaseClr: row.purchaseClr || "", ratePerLtr: row.ratePerLtr || ""
        }))
      })
      if (r.data.success !== false) {
        alert(r.data.data || (r.data.saved + " purchase(s) saved."))
        if (r.data.saved > 0) { fetchData(); setBaOpen(false); resetBa() }
      } else { alert(r.data.data || "Save failed.") }
    } catch(e) { alert(e.response?.data?.data || "Save failed.") }
    setBaSaving(false)
  }


  // â”€â”€ More Actions Dropdown â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [moreOpen, setMoreOpen] = useState(false)
  const moreRef = useRef(null)
  useEffect(() => {
    const handler = e => { if (moreRef.current && !moreRef.current.contains(e.target)) setMoreOpen(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  // Shared cascade helper for all 3 More Actions modals
  const maCascade = {
    onPlant: async (v, setPlant, setCC, setRoute, setColl, setCCs, setRoutes, setColls, reset) => {
      console.log('[CASCADE] onPlant v=', v); setPlant(v); setCC(''); setRoute(''); setColl(''); setCCs([]); setRoutes([]); setColls([]); reset()
      if (v) try { const r = await api.get('chillings-by-plant/' + v); console.log('[CASCADE] chillings resp:', r.data); setCCs(arr(r)) } catch(e) { console.error('[CASCADE] onPlant err:', e) }
    },
    onCC: async (v, setCC, setRoute, setColl, setRoutes, setColls, reset) => {
      console.log('[CASCADE] onCC v=', v); setCC(v); setRoute(''); setColl(''); setRoutes([]); setColls([]); reset()
      if (v) try { const r = await api.get('route-cc/' + v); console.log('[CASCADE] routes resp:', r.data); setRoutes(arr(r)) } catch(e) { console.error('[CASCADE] onCC err:', e) }
    },
    onRoute: async (v, setRoute, setColl, setColls, reset) => {
      console.log('[CASCADE] onRoute v=', v); setRoute(v); setColl(''); setColls([]); reset()
      if (v) try { const r = await api.get('collection-center-route/' + v); console.log('[CASCADE] centers resp:', r.data); setColls(arr(r)) } catch(e) { console.error('[CASCADE] onRoute err:', e) }
    },
  }

  const openMoreModal = () => {
    api.get('companies').then(r => { const list = arr(r); setCompanies(list) }).catch(() => {})
  }

  // â”€â”€ Modal 1: Send Purchase SMS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [smOpen, setSmOpen]           = useState(false)
  const [smCompany, setSmCompany]     = useState('')
  const [smPlant, setSmPlant]         = useState('')
  const [smCC, setSmCC]               = useState('')
  const [smRoute, setSmRoute]         = useState('')
  const [smColl, setSmColl]           = useState('')
  const [smPlants, setSmPlants]       = useState([])
  const [smCCs, setSmCCs]             = useState([])
  const [smRoutes, setSmRoutes]       = useState([])
  const [smColls, setSmColls]         = useState([])
  const [smDate, setSmDate]           = useState('')
  const [smShift, setSmShift]         = useState('')
  const [smIgnore, setSmIgnore]       = useState(false)
  const [smPreviewRows, setSmPreviewRows] = useState([])
  const [smPreviewMeta, setSmPreviewMeta] = useState(null)
  const [smPreviewLoading, setSmPreviewLoading] = useState(false)
  const [smSending, setSmSending]     = useState(false)
  const [smResult, setSmResult]       = useState(null)

  const resetSm = () => { setSmCompany(''); setSmPlant(''); setSmCC(''); setSmRoute(''); setSmColl(''); setSmPlants([]); setSmCCs([]); setSmRoutes([]); setSmColls([]); setSmDate(''); setSmShift(''); setSmIgnore(false); setSmPreviewRows([]); setSmPreviewMeta(null); setSmResult(null) }
  const openSmModal = () => { console.log('[SM] openSmModal, companies:', companies.length); openMoreModal(); resetSm(); if (companies.length <= 1) { console.log('[SM] Loading all plants (single company)'); api.get('plants').then(r => { console.log('[SM] plants loaded:', arr(r).length); setSmPlants(arr(r)) }).catch(e => console.error('[SM] plants load err:', e)) }; setSmOpen(true) }

  const handleSmPreview = async () => {
    if (!smColl) return alert('Collection Center is required.')
    if (!smDate) return alert('Date is required.')
    if (smShift === '') return alert('Shift is required.')
    setSmPreviewLoading(true); setSmPreviewRows([]); setSmPreviewMeta(null); setSmResult(null)
    try {
      const r = await api.post('vlcc-purchase-sms-preview', { collectionCenter: smColl, date: smDate, shift: smShift, ignoreAlreadySent: smIgnore })
      setSmPreviewRows(r.data.data || [])
      setSmPreviewMeta({ total: r.data.total, willSend: r.data.willSend, noMobile: r.data.noMobile, alreadySent: r.data.alreadySent })
    } catch(e) { alert(e.response?.data?.data || 'Preview failed.') }
    setSmPreviewLoading(false)
  }

  const handleSmSend = async () => {
    if (!smPreviewMeta) return
    if (smPreviewMeta.willSend === 0) return alert('No producers to send SMS to.')
    if (!window.confirm(`Send SMS to ${smPreviewMeta.willSend} producer(s)? This cannot be undone.`)) return
    setSmSending(true); setSmResult(null)
    try {
      const r = await api.post('vlcc-purchase-sms-send', { collectionCenter: smColl, date: smDate, shift: smShift, ignoreAlreadySent: smIgnore })
      setSmResult({ success: r.data.success, message: r.data.data, sent: r.data.sent, failed: r.data.failed, errors: r.data.errors || [] })
    } catch(e) { setSmResult({ success: false, message: e.response?.data?.data || 'Send failed.', sent: 0, failed: 0, errors: [] }) }
    setSmSending(false)
  }

  // â”€â”€ Modal 2: Purchase CSV Download â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [cdOpen, setCdOpen]           = useState(false)
  const [cdPlant, setCdPlant]         = useState('')
  const [cdCC, setCdCC]               = useState('')
  const [cdRoute, setCdRoute]         = useState('')
  const [cdColl, setCdColl]           = useState('')
  const [cdPlants, setCdPlants]       = useState([])
  const [cdCCs, setCdCCs]             = useState([])
  const [cdRoutes, setCdRoutes]       = useState([])
  const [cdColls, setCdColls]         = useState([])
  const [cdDate, setCdDate]           = useState('')
  const [cdShift, setCdShift]         = useState('')
  const [cdDownloading, setCdDownloading] = useState(false)

  const resetCd = () => { setCdPlant(''); setCdCC(''); setCdRoute(''); setCdColl(''); setCdPlants([]); setCdCCs([]); setCdRoutes([]); setCdColls([]); setCdDate(''); setCdShift('') }
  const openCdModal = () => { openMoreModal(); resetCd(); if (companies.length <= 1) api.get('plants').then(r => setCdPlants(arr(r))).catch(() => {}); setCdOpen(true) }

  const handleCdDownload = async () => {
    if (!cdColl) return alert('Collection Center is required.')
    if (!cdDate) return alert('Date is required.')
    if (cdShift === '') return alert('Shift is required.')
    setCdDownloading(true)
    try {
      const r = await api.post('vlcc-purchase-csv-download', { collectionCenter: cdColl, date: cdDate, shift: cdShift }, { responseType: 'blob' })
      const shiftLbl = cdShift === '0' ? 'AM' : 'PM'
      const filename = `vlcc_purchases_${cdDate}_${shiftLbl}.csv`
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'text/csv' }))
      const a = document.createElement('a'); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove(); window.URL.revokeObjectURL(url)
    } catch(e) { alert('Download failed. Please try again.') }
    setCdDownloading(false)
  }

  // â”€â”€ Modal 3: Import From Excel - Single Shift â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [xiOpen, setXiOpen]           = useState(false)
  const [xiPlant, setXiPlant]         = useState('')
  const [xiCC, setXiCC]               = useState('')
  const [xiRoute, setXiRoute]         = useState('')
  const [xiColl, setXiColl]           = useState('')
  const [xiPlants, setXiPlants]       = useState([])
  const [xiCCs, setXiCCs]             = useState([])
  const [xiRoutes, setXiRoutes]       = useState([])
  const [xiColls, setXiColls]         = useState([])
  // xiDate/xiShift removed â€” date & shift are read per-row from the CSV file
  const [xiFile, setXiFile]           = useState(null)
  const [xiPreviewRows, setXiPreviewRows] = useState([])
  const [xiPreviewMeta, setXiPreviewMeta] = useState(null)
  const [xiPreviewLoading, setXiPreviewLoading] = useState(false)
  const [xiSaving, setXiSaving]       = useState(false)
  const [xiResult, setXiResult]       = useState(null)
  const xiFileRef = useRef(null)

  const resetXi = () => { setXiPlant(''); setXiCC(''); setXiRoute(''); setXiColl(''); setXiPlants([]); setXiCCs([]); setXiRoutes([]); setXiColls([]); setXiFile(null); setXiPreviewRows([]); setXiPreviewMeta(null); setXiResult(null); if (xiFileRef.current) xiFileRef.current.value = '' }
  const openXiModal = () => { openMoreModal(); resetXi(); if (companies.length <= 1) api.get('plants').then(r => setXiPlants(arr(r))).catch(() => {}); setXiOpen(true) }

  const handleXiPreview = async () => {
    if (!xiColl) return alert('Collection Center is required.')
    if (!xiRoute) return alert('Route is required.')
    if (!xiFile) return alert('Please select a CSV file.')
    setXiPreviewLoading(true); setXiPreviewRows([]); setXiPreviewMeta(null); setXiResult(null)
    try {
      const fd = new FormData()
      fd.append('collectionCenter', xiColl)
      fd.append('route', xiRoute)
      fd.append('file', xiFile)
      const r = await api.post('vlcc-purchase-excel-preview', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      setXiPreviewRows(r.data.data || [])
      setXiPreviewMeta({ total: r.data.total, valid: r.data.valid, invalid: r.data.invalid, notFound: r.data.notFound, dateInfo: r.data.dateInfo })
    } catch(e) { alert(e.response?.data?.data || 'Preview failed.') }
    setXiPreviewLoading(false)
  }

  const handleXiSave = async () => {
    if (!xiPreviewMeta || xiPreviewMeta.valid === 0) return alert('No valid rows to import.')
    if (!window.confirm(`Import ${xiPreviewMeta.valid} valid row(s)? Existing records with same serial no will be overwritten.`)) return
    setXiSaving(true); setXiResult(null)
    try {
      const fd = new FormData()
      fd.append('chillingCenter', xiCC)
      fd.append('route', xiRoute)
      fd.append('collectionCenter', xiColl)
      fd.append('plant', xiPlant)
      if (xiFile) fd.append('file', xiFile)
      const r = await api.post('vlcc-purchase-excel-save', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      setXiResult({ success: r.data.success, message: r.data.data || r.data.message, saved: r.data.saved, failed: r.data.failed, errors: r.data.errors || [] })
      if (r.data.success) fetchData()
    } catch(e) { setXiResult({ success: false, message: e.response?.data?.data || 'Save failed.', errors: [] }) }
    setXiSaving(false)
  }

  // â”€â”€ Color Marking Details (static modal) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [colorOpen, setColorOpen] = useState(false)

  // â”€â”€ Modal 4: External DPU Purchase Import â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [dpuOpen, setDpuOpen]         = useState(false)
  const [dpuType, setDpuType]         = useState('')
  const [dpuPlant, setDpuPlant]       = useState('')
  const [dpuCC, setDpuCC]             = useState('')
  const [dpuRoute, setDpuRoute]       = useState('')
  const [dpuPlants, setDpuPlants]     = useState([])
  const [dpuCCs, setDpuCCs]           = useState([])
  const [dpuRoutes, setDpuRoutes]     = useState([])
  const [dpuFile, setDpuFile]         = useState(null)
  const [dpuImporting, setDpuImporting] = useState(false)
  const [dpuResult, setDpuResult]     = useState(null)
  const dpuFileRef = useRef(null)

  const DPU_TYPES = [
    { value: 'standard_csv', label: 'Standard CSV' },
    { value: 'lactoscan',    label: 'Lactoscan' },
    { value: 'milkotronic',  label: 'Milkotronic' },
    { value: 'foss',         label: 'FOSS MilkoScan' },
    { value: 'afimilk',      label: 'AfiMilk' },
    { value: 'deltaway',     label: 'Deltaway' },
    { value: 'combiducer',   label: 'Combi-Ducer' },
    { value: 'milkotrend',   label: 'MilkoTrend' },
  ]

  const resetDpu = () => { setDpuType(''); setDpuPlant(''); setDpuCC(''); setDpuRoute(''); setDpuPlants([]); setDpuCCs([]); setDpuRoutes([]); setDpuFile(null); setDpuResult(null); if (dpuFileRef.current) dpuFileRef.current.value = '' }
  const openDpuModal = () => { openMoreModal(); resetDpu(); if (companies.length <= 1) api.get('plants').then(r => setDpuPlants(arr(r))).catch(() => {}); setDpuOpen(true) }

  const handleDpuImport = async () => {
    if (!dpuType) return alert('DPU Type is required.')
    if (!dpuPlant) return alert('Plant is required.')
    if (!dpuCC) return alert('Chilling Center is required.')
    if (!dpuRoute) return alert('Route is required.')
    if (!dpuFile) return alert('Please select an import file.')
    setDpuImporting(true); setDpuResult(null)
    try {
      const fd = new FormData()
      fd.append('dpuType', dpuType)
      fd.append('plant', dpuPlant)
      fd.append('chillingCenter', dpuCC)
      fd.append('route', dpuRoute)
      fd.append('file', dpuFile)
      const r = await api.post('vlcc-dpu-import', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      setDpuResult({ success: r.data.success, message: r.data.data || r.data.message, saved: r.data.saved, failed: r.data.failed, errors: r.data.errors || [] })
      if (r.data.success) fetchData()
    } catch(e) { setDpuResult({ success: false, message: e.response?.data?.data || 'Import failed.', errors: [] }) }
    setDpuImporting(false)
  }

  // â”€â”€ Modal 5: Import From Excel â€” Multiple Shift â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [xmOpen, setXmOpen]             = useState(false)
  const [xmPlant, setXmPlant]           = useState('')
  const [xmCC, setXmCC]                 = useState('')
  const [xmRoute, setXmRoute]           = useState('')
  const [xmColl, setXmColl]             = useState('')
  const [xmPlants, setXmPlants]         = useState([])
  const [xmCCs, setXmCCs]               = useState([])
  const [xmRoutes, setXmRoutes]         = useState([])
  const [xmColls, setXmColls]           = useState([])
  const [xmFile, setXmFile]             = useState(null)
  const [xmPreviewRows, setXmPreviewRows] = useState([])
  const [xmPreviewMeta, setXmPreviewMeta] = useState(null)
  const [xmPreviewLoading, setXmPreviewLoading] = useState(false)
  const [xmSaving, setXmSaving]         = useState(false)
  const [xmResult, setXmResult]         = useState(null)
  const xmFileRef = useRef(null)

  const resetXm = () => {
    setXmPlant(''); setXmCC(''); setXmRoute(''); setXmColl('')
    setXmPlants([]); setXmCCs([]); setXmRoutes([]); setXmColls([])
    setXmFile(null); setXmPreviewRows([]); setXmPreviewMeta(null); setXmResult(null)
    if (xmFileRef.current) xmFileRef.current.value = ''
  }
  const openXmModal = () => {
    openMoreModal()
    resetXm()
    if (companies.length <= 1) api.get('plants').then(r => setXmPlants(arr(r))).catch(() => {})
    setXmOpen(true)
  }

  // â”€â”€ Template CSV Downloads (pure frontend â€” no backend call) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const downloadCsvBlob = (csvContent, filename) => {
    const blob = new Blob(['\xEF\xBB\xBF' + csvContent], { type: 'text/csv;charset=utf-8;' })
    const url  = URL.createObjectURL(blob)
    const a    = document.createElement('a')
    a.href = url; a.download = filename
    document.body.appendChild(a); a.click(); a.remove()
    URL.revokeObjectURL(url)
  }

  const downloadTemplateSingleShift = () => {
    const header = 'serial_num\tproducer_number\tmilk_type (cm/bm)\tquantity\tfat\tsnf\twater %\trate'
    const sample1 = '1\tP001\tcm\t10.500\t4.50\t8.20\t0.00\t28.50'
    const sample2 = '2\tP002\tbm\t8.000\t5.00\t8.80\t0.00\t32.00'
    const sample3 = '3\tP003\tcm\t12.000\t3.80\t7.90\t0.00\t26.00'
    // Convert tabs to commas for CSV
    const toCSV = s => s.split('\t').map(c => `"${c}"`).join(',')
    const csv = [toCSV(header), toCSV(sample1), toCSV(sample2), toCSV(sample3)].join('\n')
    downloadCsvBlob(csv, 'vlcc_import_template_single_shift.csv')
  }

  const downloadTemplateMultiShift = () => {
    const header  = 'date (dd-mm-yyyy)\tshift (am/pm)\tserial_num\tproducer_number\tmilk_type (cm/bm)\tquantity\tfat\tsnf\twater %\trate'
    const today   = new Date()
    const pad     = n => String(n).padStart(2, '0')
    const dateStr = `${pad(today.getDate())}-${pad(today.getMonth() + 1)}-${today.getFullYear()}`
    const sample1 = `${dateStr}\tam\t1\tP001\tcm\t10.500\t4.50\t8.20\t0.00\t28.50`
    const sample2 = `${dateStr}\tam\t2\tP002\tbm\t8.000\t5.00\t8.80\t0.00\t32.00`
    const sample3 = `${dateStr}\tpm\t1\tP001\tcm\t9.000\t4.60\t8.30\t0.00\t28.50`
    const sample4 = `${dateStr}\tpm\t2\tP002\tbm\t7.500\t5.10\t8.90\t0.00\t32.00`
    const toCSV = s => s.split('\t').map(c => `"${c}"`).join(',')
    const csv = [toCSV(header), toCSV(sample1), toCSV(sample2), toCSV(sample3), toCSV(sample4)].join('\n')
    downloadCsvBlob(csv, 'vlcc_import_template_multi_shift.csv')
  }

  const handleXmPreview = async () => {
    if (!xmColl) return alert('Collection Center is required.')
    if (!xmRoute) return alert('Route is required.')
    if (!xmFile) return alert('Please select a CSV file.')
    setXmPreviewLoading(true); setXmPreviewRows([]); setXmPreviewMeta(null); setXmResult(null)
    try {
      const fd = new FormData()
      fd.append('collectionCenter', xmColl)
      fd.append('route', xmRoute)
      fd.append('file', xmFile)
      const r = await api.post('vlcc-purchase-multi-shift-preview', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      setXmPreviewRows(r.data.data || [])
      setXmPreviewMeta({
        total: r.data.total, valid: r.data.valid, invalid: r.data.invalid,
        notFound: r.data.notFound, dateInfo: r.data.dateInfo,
        amCount: r.data.amCount, pmCount: r.data.pmCount,
      })
    } catch(e) { alert(e.response?.data?.data || 'Preview failed.') }
    setXmPreviewLoading(false)
  }

  const handleXmSave = async () => {
    if (!xmPreviewMeta || xmPreviewMeta.valid === 0) return alert('No valid rows to import.')
    if (!window.confirm(`Import ${xmPreviewMeta.valid} valid row(s) across both shifts? Existing records will be overwritten.`)) return
    setXmSaving(true); setXmResult(null)
    try {
      const fd = new FormData()
      fd.append('collectionCenter', xmColl)
      fd.append('chillingCenter', xmCC)
      fd.append('route', xmRoute)
      fd.append('plant', xmPlant)
      fd.append('file', xmFile)
      const r = await api.post('vlcc-purchase-multi-shift-save', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      setXmResult({ success: r.data.success, message: r.data.data || r.data.message, saved: r.data.saved, failed: r.data.failed, errors: r.data.errors || [] })
      if (r.data.success) fetchData()
    } catch(e) { setXmResult({ success: false, message: e.response?.data?.data || 'Save failed.', errors: [] }) }
    setXmSaving(false)
  }

  const ib = (bg, icon, title, onClick, dis) => (
    <button title={title} onClick={onClick} disabled={dis}
      style={{ width: "32px", height: "32px", borderRadius: "4px", background: bg, color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: dis ? "not-allowed" : "pointer", opacity: dis ? 0.5 : 1 }}>
      <i className={`fas ${icon}`}></i>
    </button>
  )

  const arr = r => {
    const d = r?.data?.data
    return Array.isArray(d) ? d : d?.data || []
  }

  const fetchData = useCallback(async () => {
    setDataLoaded(false); setCheckedItems({}); setParentChecked(false)
    try {
      if (tab === TAB.PURCHASES) {
        const r = await api.get("vlcc-purchases?per_page=500")
        setData(arr(r))
      } else if (tab === TAB.IMPORTS) {
        const r = await api.get("vlcc-import-logs?per_page=500")
        setData(arr(r))
      } else if (tab === TAB.DELETED) {
        const r = await api.get("deleted-vlcc-purchases?per_page=500")
        setData(arr(r))
      }
    } catch (e) { console.error(e); setData([]) }
    setDataLoaded(true)
  }, [tab])

  useEffect(() => { fetchData() }, [fetchData])
  useEffect(() => {
    api.get("companies").then(r => setCompanies(arr(r))).catch(() => {})
  }, [])

  const switchTab = t => { setTab(t); setSearch(""); setShowFilter(false); clearFilters(); setData([]); setPage(1) }

  // Filtering
  const filtered = useMemo(() => {
    let d = data
    if (tab === TAB.PURCHASES) {
      if (fDateFrom)  d = d.filter(p => p.purchaseDate >= fDateFrom)
      if (fDateTo)    d = d.filter(p => p.purchaseDate <= fDateTo)
      if (fShift)     d = d.filter(p => String(p.shift) === fShift)
      if (fMilk)      d = d.filter(p => String(p.milkType) === fMilk)
      if (fCC)        d = d.filter(p => (p.collectionCenter || "").toLowerCase().includes(fCC.toLowerCase()))
      if (fProducer)  d = d.filter(p => (p.producer || "").toLowerCase().includes(fProducer.toLowerCase()))
    }
    if (!search) return d
    const s = search.toLowerCase()
    return d.filter(r => Object.values(r).some(v => String(v || "").toLowerCase().includes(s)))
  }, [data, tab, search, fDateFrom, fDateTo, fShift, fMilk, fCC, fProducer])

  const totalPages = Math.max(1, Math.ceil(filtered.length / perPage))
  const paged = useMemo(() => filtered.slice((page - 1) * perPage, page * perPage), [filtered, page])
  useEffect(() => setPage(1), [search, fDateFrom, fDateTo, fShift, fMilk, fCC, fProducer])

  // Checkbox
  const handleCheckbox = id => {
    setCheckedItems(prev => { const n = { ...prev, [id]: !prev[id] }; setParentChecked(paged.length > 0 && paged.every(r => n[r.id])); return n })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n); const items = {}; paged.forEach(r => { items[r.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length
  const selectedIds = Object.keys(checkedItems).filter(k => checkedItems[k])

  // Delete single
  const handleDelete = async () => {
    try {
      await api.delete("delete-vlcc-purchase/" + deleteId)
      setData(prev => prev.filter(p => p.id !== deleteId))
      setDlgTitle("Deleted"); setDlgDesc("Purchase deleted."); setSuccessDlg(true)
    } catch (e) { alert("Delete failed.") }
  }

  // Bulk delete
  const handleBulkDelete = async () => {
    try {
      await api.post("delete-multiple-vlcc-purchases", { items: selectedIds })
      setData(prev => prev.filter(p => !selectedIds.includes(String(p.id))))
      setCheckedItems({}); setParentChecked(false)
      setDlgTitle("Deleted"); setDlgDesc(`${selectedIds.length} purchases deleted.`); setSuccessDlg(true)
    } catch (e) { alert("Bulk delete failed.") }
  }

  // Restore
  const handleRestore = async (id) => {
    try {
      await api.post("restore-vlcc-purchase/" + id)
      setData(prev => prev.filter(p => p.id !== id))
      setDlgTitle("Restored"); setDlgDesc("Purchase restored."); setSuccessDlg(true)
    } catch (e) { alert("Restore failed.") }
  }

  // Export CSV
  const exportCSV = () => {
    if (!filtered.length) return
    const headers = ["#", "Collection Center", "Producer", "Date", "Shift", "S.No", "Milk", "Qty Unit", "Qty (Ltrs)", "Qty (KG)", "FAT", "SNF", "CLR", "Water%", "Rate/Ltr", "Rate/KG", "Incentive", "Time"]
    const rows = filtered.map((p, i) => [
      i + 1, p.collectionCenter || "", p.producer || "", p.purchaseDate || "",
      p.shift == 0 ? "AM" : "PM", p.serialNo || "",
      p.milkType == 1 ? "Cow" : p.milkType == 2 ? "Buffalo" : "Common",
      p.qtyUnit || "", p.qtyLtrs || "", p.qtyKg || "", p.purchaseFat || "",
      p.purchaseSnf || "", p.purchaseClr || "", p.waterPercent || "",
      p.ratePerLtr || "", p.ratePerKg || "", p.incentive || "", p.purchaseTime || ""
    ])
    const csv = [headers, ...rows].map(r => r.map(c => `"${String(c || "").replace(/"/g, '""')}"`).join(",")).join("\n")
    const b = new Blob([csv], { type: "text/csv" })
    const l = document.createElement("a"); l.href = URL.createObjectURL(b)
    l.download = `vlcc_purchases_${new Date().toISOString().slice(0, 10)}.csv`; l.click()
  }

  // Helpers
  const shiftBadge = s => (
    <span style={{ padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: 600, background: s == 0 ? "#dbeafe" : "#fef9c3", color: s == 0 ? "#1e40af" : "#854d0e" }}>
      {s == 0 ? "AM" : "PM"}
    </span>
  )
  const milkBadge = m => {
    const map = { 1: ["Cow", "#dcfce7", "#166534"], 2: ["Buffalo", "#ede9fe", "#5b21b6"], 3: ["Common", "#f1f5f9", "#475569"] }
    const [label, bg, color] = map[m] || ["â€”", "#f1f5f9", "#475569"]
    return <span style={{ padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: 600, background: bg, color }}>{label}</span>
  }

  // Pagination
  const Pager = () => totalPages <= 1 ? null : (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "4px", marginTop: "12px" }}>
      <button className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => setPage(1)}>Â«</button>
      <button className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>â€¹</button>
      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
        const start = Math.max(1, Math.min(page - 2, totalPages - 4)); const p = start + i
        return p <= totalPages ? <button key={p} className={`btn btn-sm ${p === page ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setPage(p)}>{p}</button> : null
      })}
      <button className="btn btn-sm btn-outline-secondary" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>â€º</button>
      <button className="btn btn-sm btn-outline-secondary" disabled={page >= totalPages} onClick={() => setPage(totalPages)}>Â»</button>
    </div>
  )

  return (<>
    <div className="dashBody" style={{ marginTop: "10px" }}>

      {/* ─── Unified Header: Tabs + Icons + Search in ONE row ─────────────── */}
      <div style={{
        display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px",
        marginBottom: "10px", background: "#f8f9fa",
        borderRadius: "8px", padding: "4px 8px", border: "1px solid #dee2e6",
      }}>
        {/* Tabs */}
        {[
          { id: TAB.PURCHASES, label: "VLCC Purchases",        icon: "fa-truck-loading" },
          { id: TAB.IMPORTS,   label: "Import VLCC Purchases", icon: "fa-file-import" },
          { id: TAB.DELETED,   label: "Deleted Purchases",     icon: "fa-trash-alt" },
        ].map(t => (
          <button key={t.id} onClick={() => switchTab(t.id)}
            style={{
              display: "flex", alignItems: "center", gap: "5px",
              padding: "5px 12px", border: "none", borderRadius: "6px", cursor: "pointer",
              fontWeight: 600, fontSize: "13px", whiteSpace: "nowrap",
              background: tab === t.id ? "#0d6efd" : "transparent",
              color: tab === t.id ? "#fff" : "#495057",
              transition: "background 0.15s, color 0.15s",
            }}>
            <i className={`fas ${t.icon}`} style={{ fontSize: "12px" }} />
            {t.label}
          </button>
        ))}

        {/* Divider */}
        <div style={{ width: 1, height: 24, background: "#dee2e6", margin: "0 2px" }} />
        {/* Tab 1 actions */}
        {tab === TAB.PURCHASES && (<>
          {canAdd(MID) && ib("#28a745", "fa-plus", "Purchase Bulk Add", openBa, false)}
          {canDelete(MID) && ib("#dc3545", "fa-trash", selectedCount > 0 ? `Delete ${selectedCount}` : "Delete Selected",
            () => { if (selectedCount > 0) setConfirmMulti(true); else alert("Select items first.") }, false)}
          {canExport(MID) && ib("#17a2b8", "fa-download", "Export CSV", exportCSV, !filtered.length)}
          {ib("#f59e0b", "fa-sync-alt", "Update Purchases", openUpdateModal, false)}
          {/* More Actions Dropdown */}
          <div ref={moreRef} style={{ position: "relative", display: "inline-block" }}>
            <button title="More Actions" onClick={() => setMoreOpen(v => !v)}
              style={{ height: "32px", borderRadius: "4px", background: "#0d6efd", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "5px", padding: "0 10px", fontSize: "13px", cursor: "pointer", fontWeight: 500 }}>
              <i className="fas fa-chevron-down" style={{ fontSize: "11px" }} />
            </button>
            {moreOpen && (
              <div style={{ position: "absolute", top: "36px", left: 0, zIndex: 1050, background: "#fff", border: "1px solid #dee2e6", borderRadius: "6px", boxShadow: "0 4px 18px rgba(0,0,0,.15)", minWidth: "240px", padding: "4px 0", whiteSpace: "nowrap" }}>
                {[
                  { label: "Send Purchase SMS",               icon: "fa-comment-dots", action: openSmModal, active: true },
                  { label: "Purchase CSV Download",            icon: "fa-file-csv",     action: openCdModal, active: true },
                  { label: "Import From Excel - Single Shift", icon: "fa-file-excel",   action: openXiModal, active: true },
                  { label: "Download Excel Format - Single Shift", icon: "fa-download", action: downloadTemplateSingleShift, active: true },
                  { label: "Import From Excel - Multiple Shift",   icon: "fa-file-excel", action: openXmModal, active: true },
                  { label: "Download Excel Format - Multiple Shift", icon: "fa-download", action: downloadTemplateMultiShift, active: true },
                  { label: "Import from External DPU",         icon: "fa-database",    action: openDpuModal,    active: true },
                  { label: "Show Parameter Color Details",     icon: "fa-palette",     action: () => setColorOpen(true), active: true },
                ].map((item, i) => (
                  <button key={i} disabled={!item.active}
                    onClick={() => { if (item.action) { setMoreOpen(false); item.action() } }}
                    style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", padding: "8px 16px", background: "none", border: "none", fontSize: "13px", cursor: item.active ? "pointer" : "default", textAlign: "left", color: item.active ? "#212529" : "#adb5bd" }}>
                    <i className={`fas ${item.icon}`} style={{ width: "16px", color: item.active ? "#6c757d" : "#ced4da" }} />
                    {item.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </>)}


        {/* Tab 2 actions */}
        {tab === TAB.IMPORTS && (<>
          {ib("#28a745", "fa-plus", "New Import", openImport, false)}
          {canDelete(MID) && ib("#dc3545", "fa-trash", selectedCount > 0 ? `Delete ${selectedCount}` : "Delete Selected",
            () => { if (selectedCount > 0) setConfirmMulti(true); else alert("Select items first.") }, false)}
          {canExport(MID) && ib("#17a2b8", "fa-download", "Export CSV", exportCSV, !filtered.length)}
        </>)}

        {/* Filter button â€” all tabs */}
        <button title={showFilter ? "Hide Filters" : "Show Filters"}
          onClick={() => { setShowFilter(f => { if (f) clearFilters(); return !f }) }}
          style={{ width: "32px", height: "32px", borderRadius: "4px", background: showFilter ? "#0d6efd" : "#6c757d", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer" }}>
          <i className="fas fa-filter"></i>
        </button>

        {/* Search */}
        <div style={{ flex: 1 }}></div>
        <input type="text" placeholder="Search..." value={search}
          onChange={e => { setSearch(e.target.value); setPage(1) }}
          style={{ border: "1px solid #dee2e6", borderRadius: "4px 0 0 4px", padding: "4px 10px", fontSize: "13px", width: "170px", height: "32px" }} />
        {ib("#0d6efd", "fa-search", "Search", null, false)}
      </div>

      {/* â”€â”€ Table â”€â”€ */}
      <div className="table-responsive">

        {/* â”€â”€ TAB 1: VLCC Purchases â”€â”€ */}
        {tab === TAB.PURCHASES && (
          <Table className="table mb-0 dairyTbl" style={{ fontSize: "13px" }}>
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>#</th>
                <th>Collection Center</th>
                <th>Producer</th>
                <th>Date</th>
                <th>Shift</th>
                <th>S.No</th>
                <th>Milk</th>
                <th>Qty Unit</th>
                <th>Qty (Ltrs)</th>
                <th>Qty (KG)</th>
                <th>FAT</th>
                <th>SNF</th>
                <th>CLR</th>
                <th>Water%</th>
                <th>Rate Per Ltr</th>
                <th>Rate Per KG</th>
                <th>Incentive</th>
                <th>Purchase Time</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr style={{ background: "#f0f4ff" }}>
                  <td></td><td></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Center..." value={fCC} onChange={e => setFCC(e.target.value)} /></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Producer..." value={fProducer} onChange={e => setFProducer(e.target.value)} /></td>
                  <td><input type="date" className="form-control form-control-sm" value={fDateFrom} onChange={e => setFDateFrom(e.target.value)} title="Date From" /></td>
                  <td><select className="form-control form-control-sm" value={fShift} onChange={e => setFShift(e.target.value)}>
                    <option value="">All</option><option value="0">AM</option><option value="1">PM</option>
                  </select></td>
                  <td></td>
                  <td><select className="form-control form-control-sm" value={fMilk} onChange={e => setFMilk(e.target.value)}>
                    <option value="">All</option><option value="1">Cow</option><option value="2">Buffalo</option><option value="3">Common</option>
                  </select></td>
                  <td></td><td></td><td></td><td></td><td></td><td></td>
                  <td><input type="date" className="form-control form-control-sm" value={fDateTo} onChange={e => setFDateTo(e.target.value)} title="Date To" /></td>
                  <td></td><td></td><td></td><td></td>
                  <td><button className="btn btn-sm btn-outline-danger" onClick={clearFilters}><i className="fa fa-times"></i></button></td>
                </tr>
              )}
              {!dataLoaded
                ? <tr><td colSpan={20}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
                : paged.length > 0 ? paged.map((p, i) => (
                  <tr key={p.id}>
                    <td><input type="checkbox" checked={!!checkedItems[p.id]} onChange={() => handleCheckbox(p.id)} /></td>
                    <td>{(page - 1) * perPage + i + 1}</td>
                    <td>{p.collectionCenter || "â€”"}</td>
                    <td>{p.producer || "â€”"}</td>
                    <td style={{ whiteSpace: "nowrap", fontSize: "12px" }}>{p.purchaseDate}</td>
                    <td>{shiftBadge(p.shift)}</td>
                    <td>{p.serialNo || "â€”"}</td>
                    <td>{milkBadge(p.milkType)}</td>
                    <td>{p.qtyUnit || "â€”"}</td>
                    <td><strong>{p.qtyLtrs}</strong></td>
                    <td>{p.qtyKg}</td>
                    <td style={{ fontWeight: 600, color: "#d97706" }}>{p.purchaseFat}</td>
                    <td style={{ fontWeight: 600, color: "#0284c7" }}>{p.purchaseSnf}</td>
                    <td>{p.purchaseClr}</td>
                    <td>{p.waterPercent}</td>
                    <td>Rs.{p.ratePerLtr}</td>
                    <td>Rs.{p.ratePerKg}</td>
                    <td style={{ color: "#059669", fontWeight: 600 }}>Rs.{p.incentive || "0"}</td>
                    <td style={{ fontSize: "11px", whiteSpace: "nowrap" }}>{p.purchaseTime}</td>
                    <td>
                      <div style={{ display: "flex", gap: "4px" }}>
                        {canEdit(MID) && <Link to={"/edit-vlcc-purchase/" + p.id}><button style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#0d6efd", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }}><i className="fas fa-edit"></i></button></Link>}
                      </div>
                    </td>
                  </tr>
                ))
                : <tr><td colSpan={20} className="text-center py-4"><i className="fas fa-inbox fa-2x text-muted mb-2 d-block"></i>No matching records found</td></tr>
              }
            </tbody>
          </Table>
        )}

        {/* ─── TAB 2: Import VLCC Purchases ─── */}
        {tab === TAB.IMPORTS && (
          <Table className="table mb-0 dairyTbl" style={{ fontSize: "13px" }}>
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>#</th>
                <th>Type</th>
                <th>Import For</th>
                <th>Status</th>
                <th>Added By</th>
                <th>Added At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!dataLoaded
                ? <tr><td colSpan={8}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
                : paged.length > 0 ? paged.map((r, i) => (
                  <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                    <td><input type="checkbox" checked={!!checkedItems[r.id]} onChange={() => handleCheckbox(r.id)} /></td>
                    <td style={{ textAlign: "center" }}>{(page - 1) * perPage + i + 1}</td>
                    <td><span style={{ background: "#dbeafe", color: "#1e40af", borderRadius: 4, padding: "2px 7px", fontSize: 11, fontWeight: 600 }}>{r.import_type || r.type || '-'}</span></td>
                    <td style={{ fontSize: 12 }}>{r.import_for || r.for || '-'}</td>
                    <td>
                      {r.status === 'completed' && <span style={{ color: "#16a34a", fontWeight: 600 }}><i className="fas fa-check-circle" style={{ marginRight: 4 }}/>Completed</span>}
                      {r.status === 'pending'   && <span style={{ color: "#d97706", fontWeight: 600 }}><i className="fas fa-clock" style={{ marginRight: 4 }}/>Pending</span>}
                      {r.status === 'failed'    && <span style={{ color: "#dc3545", fontWeight: 600 }}><i className="fas fa-times-circle" style={{ marginRight: 4 }}/>Failed</span>}
                      {!['completed','pending','failed'].includes(r.status) && <span style={{ color: "#6c757d" }}>{r.status || '-'}</span>}
                    </td>
                    <td style={{ fontSize: 12 }}>{r.created_by || r.addedBy || '-'}</td>
                    <td style={{ fontSize: 11, whiteSpace: "nowrap" }}>{r.created_at || r.addedAt || '-'}</td>
                    <td>
                      <button style={{ width: 28, height: 28, borderRadius: 4, background: "#6c757d", color: "#fff", border: "none", fontSize: 12, cursor: "pointer" }}
                        title="View Details" onClick={() => alert(JSON.stringify(r, null, 2))}>
                        <i className="fas fa-eye"/>
                      </button>
                    </td>
                  </tr>
                ))
                : <tr><td colSpan={8} className="text-center py-4"><i className="fas fa-inbox fa-2x text-muted mb-2 d-block"></i>No import records found</td></tr>
              }
              </tbody>
            </Table>
        )}


        {/* ── TAB 3: Deleted VLCC Purchases ── */}
        {tab === TAB.DELETED && (
          <Table className="table mb-0 dairyTbl" style={{ fontSize: "13px" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>Collection Center</th>
                <th>Producer</th>
                <th>Date</th>
                <th>Shift</th>
                <th>Serial#</th>
                <th>Milk</th>
                <th>Qty(L)</th>
                <th>FAT</th>
                <th>SNF</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!dataLoaded
                ? <tr><td colSpan={12}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
                : paged.length > 0 ? paged.map((p, i) => (
                  <tr key={p.id}>
                    <td>{(page - 1) * perPage + i + 1}</td>
                    <td>{p.collectionCenter || '-'}</td>
                    <td>{p.producer || '-'}</td>
                    <td style={{ whiteSpace: "nowrap", fontSize: "12px" }}>{p.purchaseDate}</td>
                    <td>{shiftBadge(p.shift)}</td>
                    <td>{p.serialNo || '-'}</td>
                    <td>{milkBadge(p.milkType)}</td>
                    <td><strong>{p.qtyLtrs}</strong></td>
                    <td style={{ fontWeight: 600, color: "#d97706" }}>{p.purchaseFat}</td>
                    <td style={{ fontWeight: 600, color: "#0284c7" }}>{p.purchaseSnf}</td>
                    <td>Rs.{p.totalAmount || 0}</td>
                    <td>
                      <button onClick={() => handleRestore(p.id)}
                        style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#198754", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }}
                        title="Restore"><i className="fas fa-undo"></i></button>
                    </td>
                  </tr>
                ))
                : <tr><td colSpan={12} className="text-center py-4"><i className="fas fa-inbox fa-2x text-muted mb-2 d-block"></i>No deleted purchases found</td></tr>
              }
            </tbody>
          </Table>
        )}

      </div>{/* /table-responsive */}

      {/* Pagination */}
      <Pager />

    </div>{/* /dashBody */}

    {/* ── Confirm Multi Delete Dialog ── */}
    {confirmMulti && (
      <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,.4)", zIndex: 1060, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ background: "#fff", borderRadius: "8px", padding: "24px", minWidth: "340px", boxShadow: "0 8px 32px rgba(0,0,0,.2)" }}>
          <h6 style={{ marginBottom: "12px" }}>Confirm Delete</h6>
          <p style={{ fontSize: "14px", marginBottom: "16px" }}>Delete <strong>{selectedCount}</strong> selected purchase(s)? This action cannot be undone.</p>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
            <button className="btn btn-sm btn-outline-secondary" onClick={() => setConfirmMulti(false)}>Cancel</button>
            <button className="btn btn-sm btn-danger" onClick={() => { setConfirmMulti(false); handleBulkDelete() }}>Delete</button>
          </div>
        </div>
      </div>
    )}

    {/* ── Success Dialog ── */}
    {successDlg && (
      <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,.4)", zIndex: 1060, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ background: "#fff", borderRadius: "8px", padding: "24px", minWidth: "300px", textAlign: "center", boxShadow: "0 8px 32px rgba(0,0,0,.2)" }}>
          <i className="fas fa-check-circle" style={{ fontSize: "36px", color: "#198754", marginBottom: "12px" }}></i>
          <h6>{dlgTitle}</h6>
          <p style={{ fontSize: "14px", marginBottom: "16px" }}>{dlgDesc}</p>
          <button className="btn btn-sm btn-primary" onClick={() => setSuccessDlg(false)}>OK</button>
        </div>
      </div>
    )}



    {/* â”€â”€ Modal 2: Purchase CSV Download â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
    {/* ── Modal 1: Send Purchase SMS ────────────────────────────────────── */}
    <Modal isOpen={smOpen} toggle={() => { setSmOpen(false); resetSm() }} size="xl">
      <ModalHeader toggle={() => { setSmOpen(false); resetSm() }}>
        Purchase SMS Receipt <span style={{ color: "#dc3545", fontWeight: 400, fontSize: "13px" }}>[* required]</span>
      </ModalHeader>
      <ModalBody style={{ padding: "18px 22px" }}>
        <div style={{ display: "flex", gap: "14px", flexWrap: "wrap", marginBottom: "14px" }}>
          {companies.length > 1 && (
            <div style={{ flex: "1 1 200px" }}>
              <label style={{ fontSize: "13px", fontWeight: 600 }}>Company *</label>
              <select className="form-control form-control-sm mt-1" value={smCompany || ''} onChange={e => { console.log('[SM] Company selected:', e.target.value); setSmCompany(e.target.value); setSmPlant(''); setSmCC(''); setSmRoute(''); setSmColl(''); setSmPlants([]); setSmCCs([]); setSmRoutes([]); setSmColls([]); if (e.target.value) api.get('plants-by-company/' + e.target.value).then(r => { console.log('[SM] plants-by-company loaded:', arr(r).length, arr(r)); setSmPlants(arr(r)) }).catch(e => console.error('[SM] company plants err:', e)) }}>
                <option value="">-- Select Company --</option>
                {companies.map(cp => <option key={cp.id} value={cp.id}>{cp.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Plant *</label>
            <select className="form-control form-control-sm mt-1" value={smPlant} onChange={e => maCascade.onPlant(e.target.value, setSmPlant, setSmCC, setSmRoute, setSmColl, setSmCCs, setSmRoutes, setSmColls, () => {})}>
              <option value="">-- Select Plant --</option>
              {smPlants.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Chilling Center *</label>
            <select className="form-control form-control-sm mt-1" value={smCC} disabled={!smPlant} onChange={e => maCascade.onCC(e.target.value, setSmCC, setSmRoute, setSmColl, setSmRoutes, setSmColls, () => {})}>
              <option value="">-- Select CC --</option>
              {smCCs.map(cc => <option key={cc.id} value={cc.id}>{cc.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Route *</label>
            <select className="form-control form-control-sm mt-1" value={smRoute} disabled={!smCC} onChange={e => maCascade.onRoute(e.target.value, setSmRoute, setSmColl, setSmColls, () => {})}>
              <option value="">-- Select Route --</option>
              {smRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName || r.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Collection Center *</label>
            <select className="form-control form-control-sm mt-1" value={smColl} disabled={!smRoute} onChange={e => setSmColl(e.target.value)}>
              <option value="">-- Select Collection Center --</option>
              {smColls.map(cl => <option key={cl.id} value={cl.id}>{cl.centerName || cl.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 140px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Date *</label>
            <input type="date" className="form-control form-control-sm mt-1" value={smDate} onChange={e => setSmDate(e.target.value)} />
          </div>
          <div style={{ flex: "1 1 140px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Shift *</label>
            <div style={{ display: "flex", gap: "14px", marginTop: "6px" }}>
              <label style={{ fontSize: "13px" }}><input type="radio" name="smshft" checked={smShift === '0'} onChange={() => setSmShift('0')} style={{ marginRight: 4 }}/>AM</label>
              <label style={{ fontSize: "13px" }}><input type="radio" name="smshft" checked={smShift === '1'} onChange={() => setSmShift('1')} style={{ marginRight: 4 }}/>PM</label>
            </div>
          </div>
          <div style={{ flex: "0 0 auto", alignSelf: "flex-end", paddingBottom: "2px" }}>
            <label style={{ fontSize: "13px", display: "block", marginBottom: 4 }}>
              <input type="checkbox" id="smIgnoreChk" checked={smIgnore} onChange={e => setSmIgnore(e.target.checked)} style={{ marginRight: 4 }}/>
              Ignore Already Sent
            </label>
            <button className="btn btn-primary btn-sm" onClick={handleSmPreview} disabled={smPreviewLoading || !smColl || !smDate || smShift === ''}>
              {smPreviewLoading ? <><Spinner size="sm" /> Loading...</> : 'Preview'}
            </button>
          </div>
        </div>

        {/* Preview Summary Banner */}
        {smPreviewMeta && (
          <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: "6px", padding: "8px 14px", marginBottom: "12px", fontSize: "13px", display: "flex", gap: "16px", flexWrap: "wrap", alignItems: "center" }}>
            <span><strong>{smPreviewMeta.total}</strong> records found</span>
            <span style={{ color: "#16a34a", fontWeight: 600 }}>
              <i className="fas fa-check-circle" style={{ marginRight: 4 }}/>
              Will Send: <strong>{smPreviewMeta.willSend}</strong>
            </span>
            {smPreviewMeta.noMobile > 0 && <span style={{ color: "#d97706" }}>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: 4 }}/>
              No Mobile: <strong>{smPreviewMeta.noMobile}</strong>
            </span>}
            {smPreviewMeta.alreadySent > 0 && <span style={{ color: "#6c757d" }}>
              <i className="fas fa-clock" style={{ marginRight: 4 }}/>
              Already Sent: <strong>{smPreviewMeta.alreadySent}</strong>
            </span>}
            {smPreviewMeta.total === 0 && <span style={{ color: "#dc3545", fontWeight: 600 }}>
              <i className="fas fa-info-circle" style={{ marginRight: 4 }}/>
              No purchases found for the selected Collection Center, Date &amp; Shift.
            </span>}
          </div>
        )}

        {/* SMS Send Result */}
        {smResult && (
          <div style={{ background: smResult.success ? "#f0fdf4" : "#fef2f2", border: '1px solid ' + (smResult.success ? "#86efac" : "#fca5a5"), borderRadius: "6px", padding: "10px 14px", marginBottom: "12px", fontSize: "13px" }}>
            <strong>{smResult.message}</strong>
            {smResult.errors && smResult.errors.length > 0 && <ul style={{ marginTop: "6px", marginBottom: 0, paddingLeft: "18px" }}>{smResult.errors.slice(0, 10).map((e, i) => <li key={i} style={{ color: "#991b1b" }}>{e}</li>)}</ul>}
          </div>
        )}

        {/* Empty state */}
        {!smPreviewLoading && smPreviewMeta && smPreviewMeta.total === 0 && (
          <div style={{ textAlign: "center", padding: "20px", color: "#6c757d", fontSize: "13px", border: "1px solid #dee2e6", borderRadius: "6px", marginBottom: "12px", background: "#f8f9fa" }}>
            <i className="fas fa-search" style={{ fontSize: 22, marginBottom: 8, display: "block", color: "#adb5bd" }}/>
            No VLCC purchases found for the selected Collection Center, Date &amp; Shift.
            <div style={{ fontSize: 12, marginTop: 6, color: "#adb5bd" }}>Verify the correct Collection Center, Date and Shift are selected.</div>
          </div>
        )}

        {/* Preview Table */}
        {!smPreviewLoading && smPreviewRows.length > 0 && (
          <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "6px", marginBottom: "14px" }}>
            <table className="table table-sm table-bordered mb-0" style={{ fontSize: "12px" }}>
              <thead style={{ background: "#f8f9fa", position: "sticky", top: 0, zIndex: 1 }}>
                <tr>
                  <th style={{ width: 30 }}>#</th>
                  <th style={{ minWidth: 60 }}>Prod#</th>
                  <th style={{ minWidth: 140 }}>Producer Name</th>
                  <th style={{ minWidth: 110 }}>Mobile</th>
                  <th>Qty(L)</th><th>FAT</th><th>SNF</th><th>Amount</th>
                  <th style={{ minWidth: 110 }}>SMS Status</th>
                </tr>
              </thead>
              <tbody>
                {smPreviewRows.map((r, i) => (
                  <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                    <td style={{ textAlign: "center" }}>{i + 1}</td>
                    <td><strong>{r.producerNum || '-'}</strong></td>
                    <td>{r.producerName}</td>
                    <td style={{ fontFamily: "monospace", fontSize: 11 }}>
                      {r.hasMobile ? r.mobile : <span style={{ color: "#dc3545" }}>No Mobile</span>}
                    </td>
                    <td>{r.qtyLtrs}</td><td>{r.fat}</td><td>{r.snf}</td>
                    <td>Rs.{(r.amount || 0).toFixed(2)}</td>
                    <td>
                      {r.willSend
                        ? <span style={{ color: "#16a34a", fontWeight: 600 }}><i className="fas fa-check-circle" style={{ marginRight: 4 }}/>Will Send</span>
                        : r.alreadySent
                          ? <span style={{ color: "#6c757d" }}><i className="fas fa-clock" style={{ marginRight: 4 }}/>Already Sent</span>
                          : <span style={{ color: "#dc3545" }}><i className="fas fa-exclamation-triangle" style={{ marginRight: 4 }}/>No Mobile</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Footer */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <button className="btn btn-success btn-sm" onClick={handleSmSend} disabled={smSending || !smPreviewMeta || smPreviewMeta.willSend === 0}>
            {smSending ? <><Spinner size="sm" /> Sending...</> : <><i className="fas fa-paper-plane me-1" />Send SMS</>}
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => { setSmOpen(false); resetSm() }}>Close</button>
        </div>
      </ModalBody>
    </Modal>

    <Modal isOpen={cdOpen} toggle={() => { setCdOpen(false); resetCd() }}>
      <ModalHeader toggle={() => { setCdOpen(false); resetCd() }}>
        Purchase CSV Download <span style={{ color: "#dc3545", fontWeight: 400, fontSize: "13px" }}>[* required]</span>
      </ModalHeader>
      <ModalBody style={{ padding: "20px 24px" }}>
        {/* Full-width stacked dropdowns as per screenshot */}
        {companies.length > 1 && (
          <div style={{ marginBottom: "12px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Company *</label>
            <select className="form-control form-control-sm mt-1"
              onChange={e => { api.get("plants-by-company/" + e.target.value).then(r => setCdPlants(arr(r))).catch(() => {}); setCdCCs([]); setCdRoutes([]); setCdColls([]) }}>
              <option value="">Select Company</option>
              {companies.map(c => <option key={c.id} value={c.id}>{c.companyName || c.name}</option>)}
            </select>
          </div>
        )}
        <div style={{ marginBottom: "12px" }}>
          <label style={{ fontSize: "13px", fontWeight: 600 }}>Plant *</label>
          <select className="form-control form-control-sm mt-1" value={cdPlant} onChange={e => maCascade.onPlant(e.target.value, setCdPlant, setCdCC, setCdRoute, setCdColl, setCdCCs, setCdRoutes, setCdColls, () => {})}>
            <option value=""></option>
            {cdPlants.map(p => <option key={p.id} value={p.id}>{p.plantName || p.name}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: "12px" }}>
          <label style={{ fontSize: "13px", fontWeight: 600 }}>Chilling Center *</label>
          <select className="form-control form-control-sm mt-1" value={cdCC} disabled={!cdPlant} onChange={e => maCascade.onCC(e.target.value, setCdCC, setCdRoute, setCdColl, setCdRoutes, setCdColls, () => {})}>
            <option value=""></option>
            {cdCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName || c.name}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: "12px" }}>
          <label style={{ fontSize: "13px", fontWeight: 600 }}>Route *</label>
          <select className="form-control form-control-sm mt-1" value={cdRoute} disabled={!cdCC} onChange={e => maCascade.onRoute(e.target.value, setCdRoute, setCdColl, setCdColls, () => {})}>
            <option value=""></option>
            {cdRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName || r.name}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: "12px" }}>
          <label style={{ fontSize: "13px", fontWeight: 600 }}>Collection Center *</label>
          <select className="form-control form-control-sm mt-1" value={cdColl} disabled={!cdRoute} onChange={e => setCdColl(e.target.value)}>
            <option value=""></option>
            {cdColls.map(c => <option key={c.id} value={c.id}>{c.collectionCenterName || c.centerName || c.name}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: "12px" }}>
          <label style={{ fontSize: "13px", fontWeight: 600 }}>Date *</label>
          <input type="date" className="form-control form-control-sm mt-1" value={cdDate} onChange={e => setCdDate(e.target.value)} />
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={{ fontSize: "13px", fontWeight: 600 }}>Shift *</label>
          <div style={{ display: "flex", gap: "16px", marginTop: "8px" }}>
            <label style={{ fontSize: "13px" }}><input type="radio" name="cdshft" checked={cdShift === "0"} onChange={() => setCdShift("0")} style={{ marginRight: "4px" }} />AM</label>
            <label style={{ fontSize: "13px" }}><input type="radio" name="cdshft" checked={cdShift === "1"} onChange={() => setCdShift("1")} style={{ marginRight: "4px" }} />PM</label>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <button className="btn btn-success btn-sm" onClick={handleCdDownload} disabled={cdDownloading || !cdColl || !cdDate || cdShift === ''}>
            {cdDownloading ? <><Spinner size="sm" /> Downloading...</> : <><i className="fas fa-download me-1" />Download</>}
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => { setCdOpen(false); resetCd() }}>Close</button>
        </div>
      </ModalBody>
    </Modal>

    {/* â”€â”€ Modal 3: Import From Excel - Single Shift â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
    <Modal isOpen={xiOpen} toggle={() => { setXiOpen(false); resetXi() }} size="xl">
      <ModalHeader toggle={() => { setXiOpen(false); resetXi() }}>
        Purchase Excel Import <span style={{ color: "#dc3545", fontWeight: 400, fontSize: "13px" }}>[* required]</span>
      </ModalHeader>
      <ModalBody style={{ padding: "20px 24px" }}>
        {/* Row 1: Plant | CC | Route | Center */}
        <div style={{ display: "flex", gap: "16px", marginBottom: "14px", flexWrap: "wrap" }}>
          {companies.length > 1 && (
            <div style={{ flex: "1 1 160px" }}>
              <label style={{ fontSize: "13px", fontWeight: 600 }}>Company *</label>
              <select className="form-control form-control-sm mt-1"
                onChange={e => { api.get("plants-by-company/" + e.target.value).then(r => setXiPlants(arr(r))).catch(() => {}); setXiCCs([]); setXiRoutes([]); setXiColls([]) }}>
                <option value="">Select Company</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.companyName || c.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Plant *</label>
            <select className="form-control form-control-sm mt-1" value={xiPlant} onChange={e => maCascade.onPlant(e.target.value, setXiPlant, setXiCC, setXiRoute, setXiColl, setXiCCs, setXiRoutes, setXiColls, () => { setXiPreviewRows([]); setXiPreviewMeta(null); setXiResult(null) })}>
              <option value=""></option>
              {xiPlants.map(p => <option key={p.id} value={p.id}>{p.plantName || p.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Chilling Center *</label>
            <select className="form-control form-control-sm mt-1" value={xiCC} disabled={!xiPlant} onChange={e => maCascade.onCC(e.target.value, setXiCC, setXiRoute, setXiColl, setXiRoutes, setXiColls, () => { setXiPreviewRows([]); setXiPreviewMeta(null); setXiResult(null) })}>
              <option value=""></option>
              {xiCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName || c.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Route *</label>
            <select className="form-control form-control-sm mt-1" value={xiRoute} disabled={!xiCC} onChange={e => maCascade.onRoute(e.target.value, setXiRoute, setXiColl, setXiColls, () => { setXiPreviewRows([]); setXiPreviewMeta(null); setXiResult(null) })}>
              <option value=""></option>
              {xiRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName || r.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Center *</label>
            <select className="form-control form-control-sm mt-1" value={xiColl} disabled={!xiRoute} onChange={e => { setXiColl(e.target.value); setXiPreviewRows([]); setXiPreviewMeta(null); setXiResult(null) }}>
              <option value=""></option>
              {xiColls.map(c => <option key={c.id} value={c.id}>{c.collectionCenterName || c.centerName || c.name}</option>)}
            </select>
          </div>
        </div>

        {/* Row 2: Import File + Preview (date/shift come from each CSV row) */}
        <div style={{ display: "flex", gap: "16px", marginBottom: "14px", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ flex: "3 1 300px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Import File *</label>
            <input ref={xiFileRef} type="file" accept=".csv,.txt" className="form-control form-control-sm mt-1" onChange={e => { setXiFile(e.target.files[0] || null); setXiPreviewRows([]); setXiPreviewMeta(null); setXiResult(null) }} />
          </div>
          <div>
            <button className="btn btn-primary btn-sm" onClick={handleXiPreview} disabled={xiPreviewLoading || !xiColl || !xiFile}>
              {xiPreviewLoading ? <><Spinner size="sm" /> Loading...</> : "Preview"}
            </button>
          </div>
        </div>
        {/* Date info detected from CSV */}
        {xiPreviewMeta?.dateInfo && (
          <div style={{ fontSize: "12px", color: "#6c757d", marginBottom: "8px", padding: "4px 8px", background: "#f8f9fa", borderRadius: "4px", border: "1px solid #dee2e6" }}>
            <i className="fas fa-info-circle me-1" /> Detected in CSV: {xiPreviewMeta.dateInfo}
          </div>
        )}

        {/* Preview Summary */}
        {xiPreviewMeta && (
          <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: "6px", padding: "8px 14px", marginBottom: "12px", fontSize: "13px", display: "flex", gap: "20px", flexWrap: "wrap" }}>
            <span>Total Rows: <strong>{xiPreviewMeta.total}</strong></span>
            <span style={{ color: "#16a34a" }}>âœ“ Valid: <strong>{xiPreviewMeta.valid}</strong></span>
            {xiPreviewMeta.invalid > 0 && <span style={{ color: "#dc2626" }}>âœ— Invalid: <strong>{xiPreviewMeta.invalid}</strong></span>}
            {xiPreviewMeta.notFound > 0 && <span style={{ color: "#d97706" }}>âš  Producer Not Found: <strong>{xiPreviewMeta.notFound}</strong></span>}
          </div>
        )}

        {/* Import Result */}
        {xiResult && (
          <div style={{ background: xiResult.success ? "#f0fdf4" : "#fef2f2", border: `1px solid ${xiResult.success ? "#86efac" : "#fca5a5"}`, borderRadius: "6px", padding: "10px 14px", marginBottom: "12px", fontSize: "13px" }}>
            <strong>{xiResult.message}</strong>
            {xiResult.errors?.length > 0 && <ul style={{ marginTop: "6px", marginBottom: 0, paddingLeft: "18px" }}>{xiResult.errors.slice(0, 10).map((e, i) => <li key={i} style={{ color: "#991b1b" }}>{e}</li>)}</ul>}
          </div>
        )}

        {/* Preview Table */}
        {!xiPreviewLoading && xiPreviewRows.length > 0 && (
          <div style={{ maxHeight: "240px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "6px", marginBottom: "14px" }}>
            <table className="table table-sm table-bordered mb-0" style={{ fontSize: "12px" }}>
              <thead style={{ background: "#f8f9fa", position: "sticky", top: 0 }}>
                <tr><th>Row</th><th>Serial</th><th>Prod#</th><th>Producer</th><th>Milk</th><th>Qty(L)</th><th>FAT</th><th>SNF</th><th>Rate</th><th>Total</th><th>Status</th></tr>
              </thead>
              <tbody>
                {xiPreviewRows.map((r, i) => (
                  <tr key={i} style={{ background: r.status === 'invalid' ? '#fff5f5' : r.status === 'not_found' ? '#fffbeb' : 'inherit' }}>
                    <td>{r.rowNum}</td><td>{r.serialNo}</td><td>{r.producerNum}</td><td>{r.producerName || <span style={{ color: "#dc3545" }}>Not Found</span>}</td>
                    <td>{r.milkType === 1 ? "Cow" : r.milkType === 2 ? "Buffalo" : "Common"}</td>
                    <td>{r.qtyLtrs}</td><td>{r.fat}</td><td>{r.snf || r.clr}</td>
                    <td>Rs.{r.rate}</td><td>Rs.{r.total}</td>
                    <td>
                      {r.status === 'valid'     && <span style={{ color: "#16a34a", fontWeight: 600 }}>âœ“ Valid</span>}
                      {r.status === 'invalid'   && <span style={{ color: "#dc2626", fontWeight: 600 }}>âœ— Invalid</span>}
                      {r.status === 'not_found' && <span style={{ color: "#d97706", fontWeight: 600 }}>âš  Not Found</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Footer */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <button className="btn btn-success btn-sm" onClick={handleXiSave} disabled={xiSaving || !xiPreviewMeta || xiPreviewMeta.valid === 0}>
            {xiSaving ? <><Spinner size="sm" /> Saving...</> : <><i className="fas fa-save me-1" />Save Changes</>}
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => { setXiOpen(false); resetXi() }}>Close</button>
        </div>
      </ModalBody>
    </Modal>

    {/* â”€â”€ Purchase Color Marking Details (static info modal) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
    <Modal isOpen={colorOpen} toggle={() => setColorOpen(false)}>
      <ModalHeader toggle={() => setColorOpen(false)}>
        Purchase Color Marking Details
      </ModalHeader>
      <ModalBody style={{ padding: "20px 28px" }}>
        {[
          { color: "#212529",  label: "Captured from Analyzer/Scale in App" },
          { color: "#6f42c1",  label: "Manual Entry in App" },
          { color: "#6d2a2a",  label: "Entry Modified by capturing again from Analyzer/Scale in App" },
          { color: "#dc3545",  label: "Entry Modified manually from App" },
          { color: "#fd7e14",  label: "Added from Server" },
          { color: "#b8a0d8",  label: "Updated from Server" },
          { color: "#28a745",  label: "Imported from Server" },
        ].map((item, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "16px" }}>
            <div style={{ width: "28px", height: "28px", borderRadius: "4px", background: item.color, flexShrink: 0, border: "1px solid rgba(0,0,0,.12)" }} />
            <span style={{ fontSize: "14px", color: "#212529" }}>{item.label}</span>
          </div>
        ))}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
          <button className="btn btn-secondary btn-sm" onClick={() => setColorOpen(false)}>Close</button>
        </div>
      </ModalBody>
    </Modal>

    {/* â”€â”€ External DPU Purchase Import â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
    <Modal isOpen={dpuOpen} toggle={() => { setDpuOpen(false); resetDpu() }} size="xl">
      <ModalHeader toggle={() => { setDpuOpen(false); resetDpu() }}>
        External DPU Purchase Import <span style={{ color: "#dc3545", fontWeight: 400, fontSize: "13px" }}>[* required]</span>
      </ModalHeader>
      <ModalBody style={{ padding: "20px 24px" }}>
        {/* Row 1: DPU Type | Plant | Chilling Center | Route */}
        <div style={{ display: "flex", gap: "16px", marginBottom: "14px", flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 180px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>DPU Type *</label>
            <select className="form-control form-control-sm mt-1" value={dpuType} onChange={e => { setDpuType(e.target.value); setDpuResult(null) }}>
              <option value=""></option>
              {DPU_TYPES.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
            </select>
          </div>
          {companies.length > 1 && (
            <div style={{ flex: "1 1 160px" }}>
              <label style={{ fontSize: "13px", fontWeight: 600 }}>Company *</label>
              <select className="form-control form-control-sm mt-1"
                onChange={e => { api.get("plants-by-company/" + e.target.value).then(r => setDpuPlants(arr(r))).catch(() => {}); setDpuCCs([]); setDpuRoutes([]) }}>
                <option value="">Select Company</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.companyName || c.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Plant *</label>
            <select className="form-control form-control-sm mt-1" value={dpuPlant}
              onChange={e => { const v = e.target.value; setDpuPlant(v); setDpuCC(''); setDpuRoute(''); setDpuCCs([]); setDpuRoutes([]); setDpuResult(null); if (v) api.get('chillings-by-plant/' + v).then(r => setDpuCCs(arr(r))).catch(() => {}) }}>
              <option value=""></option>
              {dpuPlants.map(p => <option key={p.id} value={p.id}>{p.plantName || p.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Chilling Center *</label>
            <select className="form-control form-control-sm mt-1" value={dpuCC} disabled={!dpuPlant}
              onChange={e => { const v = e.target.value; setDpuCC(v); setDpuRoute(''); setDpuRoutes([]); setDpuResult(null); if (v) api.get('route-cc/' + v).then(r => setDpuRoutes(arr(r))).catch(() => {}) }}>
              <option value=""></option>
              {dpuCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName || c.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Route *</label>
            <select className="form-control form-control-sm mt-1" value={dpuRoute} disabled={!dpuCC}
              onChange={e => { setDpuRoute(e.target.value); setDpuResult(null) }}>
              <option value=""></option>
              {dpuRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName || r.name}</option>)}
            </select>
          </div>
        </div>

        {/* Row 2: Import File */}
        <div style={{ display: "flex", gap: "16px", marginBottom: "14px", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ flex: "1 1 300px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Import File *</label>
            <input ref={dpuFileRef} type="file" accept=".csv,.txt,.xls,.xlsx" className="form-control form-control-sm mt-1"
              onChange={e => { setDpuFile(e.target.files[0] || null); setDpuResult(null) }} />
          </div>
          {dpuType && (
            <div style={{ fontSize: "12px", color: "#6c757d", paddingBottom: "4px" }}>
              <i className="fas fa-info-circle me-1" />
              {dpuType === 'standard_csv' ? 'Expected cols: Date, Shift, ProducerNum, MilkType, Qty, FAT, SNF, CLR'
               : dpuType === 'lactoscan'   ? 'Expected: Lactoscan standard export format'
               : dpuType === 'milkotronic' ? 'Expected: Milkotronic .csv export'
               : dpuType === 'foss'        ? 'Expected: FOSS MilkoScan report CSV'
               : 'Expected: DPU-specific CSV/text export file'}
            </div>
          )}
        </div>

        {/* Import Result */}
        {dpuResult && (
          <div style={{ background: dpuResult.success ? "#f0fdf4" : "#fef2f2", border: `1px solid ${dpuResult.success ? "#86efac" : "#fca5a5"}`, borderRadius: "6px", padding: "10px 14px", marginBottom: "12px", fontSize: "13px" }}>
            <strong>{dpuResult.message}</strong>
            {dpuResult.saved > 0 && <span style={{ marginLeft: "12px", color: "#16a34a" }}>âœ“ Saved: {dpuResult.saved}</span>}
            {dpuResult.failed > 0 && <span style={{ marginLeft: "12px", color: "#dc3545" }}>âœ— Failed: {dpuResult.failed}</span>}
            {dpuResult.errors?.length > 0 && (
              <ul style={{ marginTop: "6px", marginBottom: 0, paddingLeft: "18px" }}>
                {dpuResult.errors.slice(0, 10).map((e, i) => <li key={i} style={{ color: "#991b1b" }}>{e}</li>)}
              </ul>
            )}
          </div>
        )}

        {/* Footer */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <button className="btn btn-success btn-sm" onClick={handleDpuImport} disabled={dpuImporting || !dpuType || !dpuPlant || !dpuCC || !dpuRoute || !dpuFile}>
            {dpuImporting ? <><Spinner size="sm" /> Importing...</> : <><i className="fas fa-upload me-1" />Import</>}
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => { setDpuOpen(false); resetDpu() }}>Close</button>
        </div>
      </ModalBody>
    </Modal>

    {/* â”€â”€ Import From Excel â€” Multiple Shift â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
    <Modal isOpen={xmOpen} toggle={() => { setXmOpen(false); resetXm() }} size="xl">
      <ModalHeader toggle={() => { setXmOpen(false); resetXm() }}>
        Purchase Excel Import â€” Multiple Shift{' '}
        <span style={{ color: "#dc3545", fontWeight: 400, fontSize: "13px" }}>[* required]</span>
      </ModalHeader>
      <ModalBody style={{ padding: "20px 24px" }}>
        {/* Row 1: Plant | Chilling Center | Route | Center */}
        <div style={{ display: "flex", gap: "16px", marginBottom: "14px", flexWrap: "wrap" }}>
          {companies.length > 1 && (
            <div style={{ flex: "1 1 160px" }}>
              <label style={{ fontSize: "13px", fontWeight: 600 }}>Company *</label>
              <select className="form-control form-control-sm mt-1"
                onChange={e => { api.get("plants-by-company/" + e.target.value).then(r => setXmPlants(arr(r))).catch(() => {}); setXmCCs([]); setXmRoutes([]); setXmColls([]) }}>
                <option value="">Select Company</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.companyName || c.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Plant *</label>
            <select className="form-control form-control-sm mt-1" value={xmPlant}
              onChange={e => maCascade.onPlant(e.target.value, setXmPlant, setXmCC, setXmRoute, setXmColl, setXmCCs, setXmRoutes, setXmColls, () => { setXmPreviewRows([]); setXmPreviewMeta(null); setXmResult(null) })}>
              <option value=""></option>
              {xmPlants.map(p => <option key={p.id} value={p.id}>{p.plantName || p.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Chilling Center *</label>
            <select className="form-control form-control-sm mt-1" value={xmCC} disabled={!xmPlant}
              onChange={e => maCascade.onCC(e.target.value, setXmCC, setXmRoute, setXmColl, setXmRoutes, setXmColls, () => { setXmPreviewRows([]); setXmPreviewMeta(null); setXmResult(null) })}>
              <option value=""></option>
              {xmCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName || c.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Route *</label>
            <select className="form-control form-control-sm mt-1" value={xmRoute} disabled={!xmCC}
              onChange={e => maCascade.onRoute(e.target.value, setXmRoute, setXmColl, setXmColls, () => { setXmPreviewRows([]); setXmPreviewMeta(null); setXmResult(null) })}>
              <option value=""></option>
              {xmRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName || r.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Center *</label>
            <select className="form-control form-control-sm mt-1" value={xmColl} disabled={!xmRoute}
              onChange={e => { setXmColl(e.target.value); setXmPreviewRows([]); setXmPreviewMeta(null); setXmResult(null) }}>
              <option value=""></option>
              {xmColls.map(c => <option key={c.id} value={c.id}>{c.collectionCenterName || c.centerName || c.name}</option>)}
            </select>
          </div>
        </div>

        {/* Row 2: Import File + Preview */}
        <div style={{ display: "flex", gap: "16px", marginBottom: "8px", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ flex: "3 1 300px" }}>
            <label style={{ fontSize: "13px", fontWeight: 600 }}>Import File *</label>
            <div style={{ fontSize: "11px", color: "#6c757d", marginBottom: "3px" }}>
              <i className="fas fa-info-circle me-1" />CSV must include a <strong>Shift</strong> column with AM/PM or 0/1 values for each row
            </div>
            <input ref={xmFileRef} type="file" accept=".csv,.txt" className="form-control form-control-sm"
              onChange={e => { setXmFile(e.target.files[0] || null); setXmPreviewRows([]); setXmPreviewMeta(null); setXmResult(null) }} />
          </div>
          <div>
            <button className="btn btn-primary btn-sm" onClick={handleXmPreview} disabled={xmPreviewLoading || !xmColl || !xmFile}>
              {xmPreviewLoading ? <><Spinner size="sm" /> Loading...</> : "Preview"}
            </button>
          </div>
        </div>

        {/* Date/shift info detected from CSV */}
        {xmPreviewMeta?.dateInfo && (
          <div style={{ fontSize: "12px", color: "#6c757d", marginBottom: "10px", padding: "4px 8px", background: "#f8f9fa", borderRadius: "4px", border: "1px solid #dee2e6" }}>
            <i className="fas fa-info-circle me-1" /> {xmPreviewMeta.dateInfo}
          </div>
        )}

        {/* Summary banner */}
        {xmPreviewMeta && (
          <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: "6px", padding: "8px 14px", marginBottom: "12px", fontSize: "13px", display: "flex", gap: "20px", flexWrap: "wrap" }}>
            <span>Total: <strong>{xmPreviewMeta.total}</strong></span>
            <span style={{ color: "#16a34a" }}>âœ“ Valid: <strong>{xmPreviewMeta.valid}</strong></span>
            {xmPreviewMeta.invalid > 0  && <span style={{ color: "#dc2626" }}>âœ— Invalid: <strong>{xmPreviewMeta.invalid}</strong></span>}
            {xmPreviewMeta.notFound > 0 && <span style={{ color: "#d97706" }}>âš  Not Found: <strong>{xmPreviewMeta.notFound}</strong></span>}
            {xmPreviewMeta.amCount > 0  && <span style={{ color: "#0d6efd" }}>AM Shift: <strong>{xmPreviewMeta.amCount}</strong></span>}
            {xmPreviewMeta.pmCount > 0  && <span style={{ color: "#6f42c1" }}>PM Shift: <strong>{xmPreviewMeta.pmCount}</strong></span>}
          </div>
        )}

        {/* Import result */}
        {xmResult && (
          <div style={{ background: xmResult.success ? "#f0fdf4" : "#fef2f2", border: `1px solid ${xmResult.success ? "#86efac" : "#fca5a5"}`, borderRadius: "6px", padding: "10px 14px", marginBottom: "12px", fontSize: "13px" }}>
            <strong>{xmResult.message}</strong>
            {xmResult.saved > 0 && <span style={{ marginLeft: "10px", color: "#16a34a" }}>âœ“ Saved: {xmResult.saved}</span>}
            {xmResult.failed > 0 && <span style={{ marginLeft: "10px", color: "#dc3545" }}>âœ— Skipped: {xmResult.failed}</span>}
            {xmResult.errors?.length > 0 && (
              <ul style={{ marginTop: "6px", marginBottom: 0, paddingLeft: "18px" }}>
                {xmResult.errors.slice(0, 10).map((e, i) => <li key={i} style={{ color: "#991b1b" }}>{e}</li>)}
              </ul>
            )}
          </div>
        )}

        {/* Preview table â€” includes Shift column */}
        {!xmPreviewLoading && xmPreviewRows.length > 0 && (
          <div style={{ maxHeight: "260px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "6px", marginBottom: "14px" }}>
            <table className="table table-sm table-bordered mb-0" style={{ fontSize: "12px" }}>
              <thead style={{ background: "#f8f9fa", position: "sticky", top: 0 }}>
                <tr>
                  <th>Row</th><th>Serial</th><th>Prod#</th><th>Producer</th>
                  <th>Shift</th><th>Date</th><th>Milk</th>
                  <th>Qty(L)</th><th>FAT</th><th>SNF</th><th>Rate</th><th>Total</th><th>Status</th>
                </tr>
              </thead>
              <tbody>
                {xmPreviewRows.map((r, i) => (
                  <tr key={i} style={{ background: r.status === 'invalid' ? '#fff5f5' : r.status === 'not_found' ? '#fffbeb' : 'inherit' }}>
                    <td>{r.rowNum}</td>
                    <td>{r.serialNo}</td>
                    <td>{r.producerNum}</td>
                    <td>{r.producerName || <span style={{ color: "#dc3545" }}>Not Found</span>}</td>
                    <td>
                      <span style={{ padding: "1px 6px", borderRadius: "10px", fontSize: "11px", fontWeight: 600,
                        background: r.shift === 1 ? "#ede9fe" : "#dbeafe",
                        color: r.shift === 1 ? "#6d28d9" : "#1d4ed8" }}>
                        {r.shift === 1 ? "PM" : "AM"}
                      </span>
                    </td>
                    <td>{r.rowDate || <span style={{ color: "#adb5bd" }}>â€”</span>}</td>
                    <td>{r.milkType === 1 ? "Cow" : r.milkType === 2 ? "Buffalo" : "Common"}</td>
                    <td>{r.qtyLtrs}</td><td>{r.fat}</td><td>{r.snf || r.clr}</td>
                    <td>Rs.{r.rate}</td><td>Rs.{r.total}</td>
                    <td>
                      {r.status === 'valid'     && <span style={{ color: "#16a34a", fontWeight: 600 }}>âœ“ Valid</span>}
                      {r.status === 'invalid'   && <span style={{ color: "#dc2626", fontWeight: 600 }}>âœ— Invalid</span>}
                      {r.status === 'not_found' && <span style={{ color: "#d97706", fontWeight: 600 }}>âš  Not Found</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Footer */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <button className="btn btn-success btn-sm" onClick={handleXmSave} disabled={xmSaving || !xmPreviewMeta || xmPreviewMeta.valid === 0}>
            {xmSaving ? <><Spinner size="sm" /> Saving...</> : <><i className="fas fa-save me-1" />Save Changes</>}
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => { setXmOpen(false); resetXm() }}>Close</button>
        </div>
      </ModalBody>
    </Modal>

    {/* ══ PURCHASE BULK ADD MODAL ══════════════════════════════════════════ */}
    <Modal isOpen={baOpen} toggle={() => { setBaOpen(false); resetBa() }} size="xl" scrollable>
      <ModalHeader toggle={() => { setBaOpen(false); resetBa() }}>
        <strong>Purchase Bulk Add</strong> <span style={{ color: "#dc3545", fontWeight: 400, fontSize: 13 }}>[* required]</span>
      </ModalHeader>
      <ModalBody style={{ padding: "18px 22px" }}>
        {/* Row 1: Company(if>1) | Plant | CC | Route | Collection Center */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
          {companies.length > 1 && (
            <div style={{ flex: "1 1 170px" }}>
              <label style={{ fontSize: 12, fontWeight: 600 }}>Company <span style={{ color: "red" }}>*</span></label>
              <select className="form-control form-control-sm" value={baCompany}
                onChange={e => onBaCompany(e.target.value)} style={{ color: "#212529" }}>
                <option value="">Select</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.companyName || c.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ flex: "1 1 180px" }}>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Plant <span style={{ color: "red" }}>*</span></label>
            <select className="form-control form-control-sm" value={baPlant}
              onChange={e => onBaPlant(e.target.value)} style={{ color: "#212529" }}>
              <option value="">Select</option>
              {baPlants.map(p => <option key={p.id} value={p.id}>{p.plantName || p.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Chilling Center <span style={{ color: "red" }}>*</span></label>
            <select className="form-control form-control-sm" value={baCC}
              onChange={e => onBaCC(e.target.value)} disabled={!baPlant} style={{ color: "#212529" }}>
              <option value="">Select</option>
              {baCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName || c.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 180px" }}>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Route <span style={{ color: "red" }}>*</span></label>
            <select className="form-control form-control-sm" value={baRoute}
              onChange={e => onBaRoute(e.target.value)} disabled={!baCC} style={{ color: "#212529" }}>
              <option value="">Select</option>
              {baRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName || r.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Collection Center <span style={{ color: "red" }}>*</span></label>
            <select className="form-control form-control-sm" value={baCollection}
              onChange={e => onBaCollection(e.target.value)} disabled={!baRoute} style={{ color: "#212529" }}>
              <option value="">Select</option>
              {baCollections.map(c => <option key={c.id} value={c.id}>{c.centerName || c.name}</option>)}
            </select>
          </div>
        </div>
        {/* Row 2: Date | Shift | Entry Mode | Use Short Num */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
          <div style={{ flex: "1 1 145px" }}>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Date <span style={{ color: "red" }}>*</span></label>
            <input type="date" className="form-control form-control-sm" value={baDate}
              onChange={e => setBaDate(e.target.value)} />
          </div>
          <div style={{ flex: "0 0 120px" }}>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Shift <span style={{ color: "red" }}>*</span></label>
            <div style={{ paddingTop: 6 }}>
              <label style={{ marginRight: 12, cursor: "pointer" }}>
                <input type="radio" name="baShift" value="0" checked={baShift === "0"} onChange={() => setBaShift("0")} /> AM
              </label>
              <label style={{ cursor: "pointer" }}>
                <input type="radio" name="baShift" value="1" checked={baShift === "1"} onChange={() => setBaShift("1")} /> PM
              </label>
            </div>
          </div>
          <div style={{ flex: "0 0 140px" }}>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Entry Mode <span style={{ color: "red" }}>*</span></label>
            <div style={{ paddingTop: 6 }}>
              <label style={{ marginRight: 12, cursor: "pointer" }}>
                <input type="radio" name="baMode" value="SNF" checked={baMode === "SNF"} onChange={() => setBaMode("SNF")} /> SNF
              </label>
              <label style={{ cursor: "pointer" }}>
                <input type="radio" name="baMode" value="CLR" checked={baMode === "CLR"} onChange={() => setBaMode("CLR")} /> CLR
              </label>
            </div>
          </div>
          <div style={{ flex: "0 0 200px" }}>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Use Producer Short Number <span style={{ color: "red" }}>*</span></label>
            <div style={{ paddingTop: 6 }}>
              <label style={{ marginRight: 12, cursor: "pointer" }}>
                <input type="radio" name="baShortNum" value="Yes" checked={baUseShortNum === "Yes"} onChange={() => setBaUseShortNum("Yes")} /> Yes
              </label>
              <label style={{ cursor: "pointer" }}>
                <input type="radio" name="baShortNum" value="No" checked={baUseShortNum === "No"} onChange={() => setBaUseShortNum("No")} /> No
              </label>
            </div>
          </div>
        </div>

        {/* Rate chart warning */}
        {baRateAvail === false && (
          <div style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: 6, padding: "8px 14px", marginBottom: 12, fontSize: 13, color: "#991b1b" }}>
            <i className="fas fa-exclamation-triangle" style={{ marginRight: 6 }} />
            <strong>No rate chart found for this collection center.</strong> Rates will default to 0 unless configured.
          </div>
        )}

        {/* Add New Button */}
        <div style={{ marginBottom: 10 }}>
          <button className="btn btn-primary btn-sm"
            disabled={!baPlant || !baCC || !baRoute || !baCollection || !baDate}
            onClick={() => { setBaShowTable(true); setBaRows(r => [...r, defaultBaRow()]) }}
            style={{ minWidth: 90 }}>
            <i className="fas fa-plus" style={{ marginRight: 5 }} /> Add New
          </button>
          {(!baPlant || !baCC || !baRoute || !baCollection || !baDate) && (
            <small style={{ marginLeft: 10, color: "#6c757d" }}>Fill all required fields to add rows</small>
          )}
        </div>

        {/* Rows Table */}
        {baShowTable && baRows.length > 0 && (
          <div className="table-responsive">
            <table className="table table-sm table-bordered" style={{ fontSize: 12, minWidth: 820 }}>
              <thead style={{ background: "#e9ecef" }}>
                <tr>
                  <th style={{ width: 28, textAlign: "center" }}>#</th>
                  <th style={{ minWidth: 80 }}>Pro Num</th>
                  <th style={{ minWidth: 140 }}>Pro Name</th>
                  <th style={{ minWidth: 80 }}>Milk</th>
                  <th style={{ minWidth: 75 }}>Qty</th>
                  <th style={{ minWidth: 65 }}>FAT</th>
                  {baMode === "SNF" ? <th style={{ minWidth: 65 }}>SNF</th> : <th style={{ minWidth: 65 }}>CLR</th>}
                  <th style={{ minWidth: 65 }}>Rate</th>
                  <th style={{ width: 32 }}></th>
                </tr>
              </thead>
              <tbody>
                {baRows.map((row, i) => (
                  <tr key={i}>
                    <td style={{ textAlign: "center", verticalAlign: "middle", color: "#6c757d" }}>{i + 1}</td>
                    <td>
                      <input type="text" className="form-control form-control-sm" value={row.producerNum}
                        onChange={e => setBaRowField(i, "producerNum", e.target.value)}
                        onBlur={e => lookupProducer(i, e.target.value)}
                        style={{ width: 75, borderColor: row.lookupState === "err" ? "#dc3545" : row.lookupState === "ok" ? "#28a745" : "" }} />
                    </td>
                    <td style={{ verticalAlign: "middle", fontSize: 11, color: row.lookupState === "err" ? "#dc3545" : "#212529" }}>
                      {row.lookupState === "loading" ? <i className="fas fa-spinner fa-spin" /> : row.producerName || ""}
                    </td>
                    <td>
                      <select className="form-control form-control-sm" value={row.milkType}
                        onChange={e => setBaRowField(i, "milkType", e.target.value)} style={{ minWidth: 68, color: "#212529" }}>
                        <option value="1">Cow</option><option value="2">Buffalo</option><option value="3">Common</option>
                      </select>
                    </td>
                    <td><input type="number" className="form-control form-control-sm" value={row.qty}
                      onChange={e => setBaRowField(i, "qty", e.target.value)} step="0.001" style={{ width: 70 }} placeholder="0.000" /></td>
                    <td><input type="number" className="form-control form-control-sm" value={row.purchaseFat}
                      onChange={e => setBaRowField(i, "purchaseFat", e.target.value)} step="0.01" style={{ width: 62 }} placeholder="0.00" /></td>
                    {baMode === "SNF"
                      ? <td><input type="number" className="form-control form-control-sm" value={row.purchaseSnf}
                          onChange={e => setBaRowField(i, "purchaseSnf", e.target.value)} step="0.01" style={{ width: 62 }} placeholder="0.00" /></td>
                      : <td><input type="number" className="form-control form-control-sm" value={row.purchaseClr}
                          onChange={e => setBaRowField(i, "purchaseClr", e.target.value)} step="0.1" style={{ width: 62 }} placeholder="0.0" /></td>
                    }
                    <td style={{ verticalAlign: "middle", fontSize: 11, color: row.rateLookupState === "ok" ? "#16a34a" : row.rateLookupState === "err" ? "#dc3545" : "#6c757d" }}>
                      {row.ratePerLtr ? parseFloat(row.ratePerLtr).toFixed(2) : "-"}
                    </td>
                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                      {baRows.length > 1 && (
                        <button className="btn btn-sm btn-outline-danger" style={{ padding: "1px 6px", fontSize: 11 }}
                          onClick={() => setBaRows(prev => prev.filter((_, j) => j !== i))}>
                          <i className="fas fa-times" />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </ModalBody>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, padding: "10px 22px", borderTop: "1px solid #dee2e6" }}>
        <button className="btn btn-success btn-sm" onClick={handleBaSave} disabled={baSaving || !baShowTable}>
          {baSaving ? <><Spinner size="sm" /> Saving...</> : <><i className="fas fa-save" style={{ marginRight: 5 }} />Save Changes</>}
        </button>
        <button className="btn btn-danger btn-sm" onClick={() => { setBaOpen(false); resetBa() }}>Close</button>
      </div>
    </Modal>


    {/* ══ PURCHASE UPDATE MODAL ════════════════════════════════════════════ */}
    <Modal isOpen={updateOpen} toggle={() => { setUpdateOpen(false); resetUpdate() }} size="xl" scrollable>
      <ModalHeader toggle={() => { setUpdateOpen(false); resetUpdate() }}>
        <strong>Bulk Purchase Update</strong> <span style={{ color: "#dc3545", fontWeight: 400, fontSize: 13 }}>[* required]</span>
      </ModalHeader>
      <ModalBody style={{ padding: "18px 22px" }}>
        {/* Row 1: Company | Plant | CC | Route */}
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 12 }}>
          {companies.length > 1 && (
            <div style={{ flex: "1 1 150px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Company *</label>
              <select className="form-control form-control-sm mt-1" value={uCompany}
                onChange={e => onUCompany(e.target.value)} style={{ color: "#212529" }}>
                <option value="">Select</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.companyName || c.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ flex: "1 1 170px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Plant *</label>
            <select className="form-control form-control-sm mt-1" value={uPlant}
              onChange={e => onUPlant(e.target.value)} style={{ color: "#212529" }}>
              <option value="">Select</option>
              {uPlants.map(p => <option key={p.id} value={p.id}>{p.plantName || p.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Chilling Center *</label>
            <select className="form-control form-control-sm mt-1" value={uCC}
              onChange={e => onUCC(e.target.value)} disabled={!uPlant} style={{ color: "#212529" }}>
              <option value="">Select</option>
              {uCCs.map(c => <option key={c.id} value={c.id}>{c.chillingCenterName || c.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 180px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Route <small style={{ color: "#6c757d" }}>(optional)</small></label>
            <select className="form-control form-control-sm mt-1" value={uRoute}
              onChange={e => onURoute(e.target.value)} disabled={!uCC} style={{ color: "#212529" }}>
              <option value="">All Routes</option>
              {uRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName || r.name}</option>)}
            </select>
          </div>
        </div>
        {/* Row 2: Collection Center | Producer | Display | Date/Period */}
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 12 }}>
          <div style={{ flex: "1 1 180px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Collection Center <small style={{ color: "#6c757d" }}>(optional)</small></label>
            <select className="form-control form-control-sm mt-1" value={uCollection}
              onChange={e => onUCollection(e.target.value)} disabled={!uRoute} style={{ color: "#212529" }}>
              <option value="">All Centers</option>
              {uCollections.map(c => <option key={c.id} value={c.id}>{c.centerName || c.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 180px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Producer <small style={{ color: "#6c757d" }}>(optional)</small></label>
            <select className="form-control form-control-sm mt-1" value={uProducer}
              onChange={e => { setUProducer(e.target.value); setPreviewRows([]); setUpdateResult(null) }}
              disabled={!uCollection} style={{ color: "#212529" }}>
              <option value="">All Producers</option>
              {uProducers.map(p => <option key={p.id} value={p.id}>{p.producerName || p.name}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Display *</label>
            <select className="form-control form-control-sm mt-1" value={uDisplay}
              onChange={e => { setUDisplay(e.target.value); setPreviewRows([]); setUpdateResult(null) }} style={{ color: "#212529" }}>
              <option value="single">Single Shift</option>
              <option value="period">Period</option>
            </select>
          </div>
          {uDisplay === "single" ? (
            <div style={{ flex: "1 1 145px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Date *</label>
              <input type="date" className="form-control form-control-sm mt-1" value={uDate}
                onChange={e => { setUDate(e.target.value); setPreviewRows([]); setUpdateResult(null) }} />
            </div>
          ) : (<>
            <div style={{ flex: "1 1 145px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>From *</label>
              <input type="date" className="form-control form-control-sm mt-1" value={uPeriodFrom}
                onChange={e => { setUPeriodFrom(e.target.value); setPreviewRows([]); setUpdateResult(null) }} />
            </div>
            <div style={{ flex: "1 1 145px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>To *</label>
              <input type="date" className="form-control form-control-sm mt-1" value={uPeriodTo}
                onChange={e => { setUPeriodTo(e.target.value); setPreviewRows([]); setUpdateResult(null) }} />
            </div>
          </>)}
        </div>
        {/* Row 3: Shift | Milk Type | Entry Mode | Use Custom Rate */}
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 12 }}>
          <div style={{ flex: "0 0 130px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Shift *</label>
            <select className="form-control form-control-sm mt-1" value={uShift}
              onChange={e => { setUShift(e.target.value); setPreviewRows([]); setUpdateResult(null) }} style={{ color: "#212529" }}>
              <option value="">Both</option><option value="0">AM</option><option value="1">PM</option>
            </select>
          </div>
          <div style={{ flex: "1 1 160px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Milk Type *</label>
            <select className="form-control form-control-sm mt-1" value={uMilkType}
              onChange={e => onUMilkType(e.target.value)} style={{ color: "#212529" }}>
              <option value="">Both</option><option value="1">Cow Milk</option><option value="2">Buffalo Milk</option><option value="3">Common</option>
            </select>
          </div>
          <div style={{ flex: "0 0 130px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Entry Mode</label>
            <select className="form-control form-control-sm mt-1" value={uEntryMode}
              onChange={e => { setUEntryMode(e.target.value); setPreviewRows([]); setUpdateResult(null) }} style={{ color: "#212529" }}>
              <option value="SNF">SNF</option><option value="CLR">CLR</option>
            </select>
          </div>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Use Custom Rate Chart</label>
            <select className="form-control form-control-sm mt-1" value={uUseCustomRate}
              onChange={e => onUUseCustomRate(e.target.value)} style={{ color: "#212529" }}>
              <option value="No">No</option><option value="Yes">Yes</option>
            </select>
          </div>
        </div>
        {/* Row 3b: Custom chart selection */}
        {uUseCustomRate === "Yes" && (
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 12 }}>
            <div style={{ flex: "1 1 300px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Custom Common Milk Chart *</label>
              <select className="form-control form-control-sm mt-1" value={uRateChartId}
                onChange={e => { setURateChartId(e.target.value); setPreviewRows([]); setUpdateResult(null) }} style={{ color: "#212529" }}>
                <option value="">Select Chart</option>
                {uRateCharts.map(ch => <option key={ch.id} value={ch.id}>{ch.chartLabel || ch.name || `Chart #${ch.id}`}</option>)}
              </select>
            </div>
          </div>
        )}
        {/* Row 4: Apply Custom Incentive */}
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 12 }}>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Apply Custom Incentive</label>
            <select className="form-control form-control-sm mt-1" value={uApplyIncentive}
              onChange={e => { setUApplyIncentive(e.target.value); setPreviewRows([]); setUpdateResult(null) }} style={{ color: "#212529" }}>
              <option value="no">No</option>
              <option value="chart">Incentive Chart Based</option>
              <option value="flat">Flat Incentive</option>
            </select>
          </div>
          {uApplyIncentive === "chart" && (
            <div style={{ flex: "1 1 250px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Custom Incentive Chart *</label>
              <select className="form-control form-control-sm mt-1" value={uIncentiveChartId}
                onChange={e => { setUIncentiveChartId(e.target.value); setPreviewRows([]); setUpdateResult(null) }} style={{ color: "#212529" }}>
                <option value="">Select Chart</option>
                {uIncentiveCharts.map(ch => <option key={ch.id} value={ch.id}>{ch.name || `Incentive #${ch.id}`}</option>)}
              </select>
            </div>
          )}
          {uApplyIncentive === "flat" && (
            <div style={{ flex: "1 1 180px" }}>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Flat Incentive / Liter *</label>
              <input type="number" min="0" step="0.01" className="form-control form-control-sm mt-1"
                placeholder="e.g. 0.50" value={uFlatIncentive}
                onChange={e => { setUFlatIncentive(e.target.value); setPreviewRows([]); setUpdateResult(null) }} />
            </div>
          )}
        </div>

        {/* Loading */}
        {previewLoading && <div style={{ textAlign: "center", padding: 24, color: "#6c757d" }}><i className="fas fa-spinner fa-spin" style={{ fontSize: 20 }} />&nbsp;Loading preview...</div>}


        {/* Manipulate Values + Summary + Table */}
        {!previewLoading && previewRows.length > 0 && (() => {
          const oldSt = uOldSummary(originalPreviewRows)
          const newSt = uNewSummary(previewRows)
          const hasDiff = (a, b) => Math.abs(parseFloat(a || 0) - parseFloat(b || 0)) > 0.0001
          const newCell = (nv, ov) => ({ background: "#fff59d", color: hasDiff(nv, ov) ? (nv > ov ? "#16a34a" : "#dc2626") : "#212529", fontWeight: hasDiff(nv, ov) ? 700 : 400 })
          return (
            <div>
              <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 8 }}>Manipulate Values</div>
              <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", background: "#f8f9fa", border: "1px solid #dee2e6", borderRadius: 6, padding: "8px 12px", marginBottom: 10 }}>
                <select className="form-control form-control-sm" style={{ width: 105 }} value={uOvAction} onChange={e => setUOvAction(e.target.value)}>
                  <option value="increase">Increase</option><option value="decrease">Decrease</option>
                </select>
                <select className="form-control form-control-sm" style={{ width: 135 }} value={uOvField} onChange={e => setUOvField(e.target.value)}>
                  <option value="qty">Total Quantity</option><option value="fat">FAT</option>
                  <option value="snf">SNF</option><option value="clr">CLR</option><option value="rate">Rate / Ltr</option>
                </select>
                <span style={{ fontSize: 13, color: "#495057", fontWeight: 500 }}>By</span>
                <input type="number" step="0.001" className="form-control form-control-sm" style={{ width: 80 }} value={uOvBy} onChange={e => setUOvBy(e.target.value)} placeholder="Value" />
                <span style={{ fontSize: 13, color: "#495057", fontWeight: 500 }}>when</span>
                <select className="form-control form-control-sm" style={{ width: 110 }} value={uOvCondField} onChange={e => setUOvCondField(e.target.value)}>
                  <option value="qty">Quantity</option><option value="fat">FAT</option>
                  <option value="snf">SNF</option><option value="clr">CLR</option><option value="rate">Rate</option>
                </select>
                <span style={{ fontSize: 13, color: "#495057", fontWeight: 500 }}>between</span>
                <input type="number" step="0.001" placeholder="Min" className="form-control form-control-sm" style={{ width: 72 }} value={uOvCondMin} onChange={e => setUOvCondMin(e.target.value)} />
                <span style={{ fontSize: 13, color: "#495057", fontWeight: 500 }}>and</span>
                <input type="number" step="0.001" placeholder="Max" className="form-control form-control-sm" style={{ width: 72 }} value={uOvCondMax} onChange={e => setUOvCondMax(e.target.value)} />
                <button className="btn btn-primary btn-sm" onClick={applyManipulate} style={{ fontWeight: 600, minWidth: 95 }}>Manipulate</button>
                <button className="btn btn-outline-secondary btn-sm" title="Reset to original values" onClick={() => setPreviewRows(originalPreviewRows.map(r => ({ ...r })))}><i className="fas fa-undo" /></button>
              </div>
              <div style={{ fontSize: 13, marginBottom: 8 }}>
                <div style={{ color: "#6c757d", marginBottom: 3 }}>
                  <b style={{ display: "inline-block", minWidth: 100 }}>Old Summary</b>
                  &nbsp;Total Quantity : <b>{oldSt.qty}</b>&nbsp;&nbsp;Avg FAT : <b>{oldSt.fat}</b>&nbsp;&nbsp;Avg SNF : <b>{oldSt.snf}</b>&nbsp;&nbsp;Avg Rate : <b>{oldSt.rate}</b>&nbsp;&nbsp;Amount : <b>{oldSt.amount}</b>
                </div>
                <div style={{ color: "#0d6efd", marginBottom: 3 }}>
                  <b style={{ display: "inline-block", minWidth: 100 }}>New Summary</b>
                  &nbsp;Total Quantity : <b>{newSt.qty}</b>&nbsp;&nbsp;Avg FAT : <b>{newSt.fat}</b>&nbsp;&nbsp;Avg SNF : <b>{newSt.snf}</b>&nbsp;&nbsp;Avg Rate : <b>{newSt.rate}</b>&nbsp;&nbsp;Amount : <b>{newSt.amount}</b>
                </div>
                <div><b>Total Entries : {previewRows.length}</b>
                  {previewTotal > 300 && <span style={{ color: "#d97706", marginLeft: 10, fontSize: 12 }}>(showing first 300 — all {previewTotal} will be updated on save)</span>}
                </div>
              </div>
              <div style={{ maxHeight: 300, overflowY: "auto", overflowX: "auto", border: "1px solid #dee2e6", borderRadius: 6 }}>
                <table className="table table-sm table-bordered mb-0" style={{ fontSize: 11, minWidth: 1100 }}>
                  <thead style={{ background: "#f8f9fa", position: "sticky", top: 0, zIndex: 1 }}>
                    <tr>
                      <th style={{ width: 30, textAlign: "center" }}>#</th>
                      <th style={{ minWidth: 130 }}>Producer</th>
                      <th style={{ minWidth: 85 }}>Date</th><th style={{ width: 42 }}>Shift</th><th style={{ width: 46 }}>Milk</th>
                      <th>Old Qty</th><th style={{ background: "#fff59d" }}>New Qty</th>
                      <th>Old FAT</th><th style={{ background: "#fff59d" }}>New FAT</th>
                      <th>Old SNF</th><th style={{ background: "#fff59d" }}>New SNF</th>
                      <th>Old Rate</th><th style={{ background: "#fff59d" }}>New Rate</th>
                      <th>Old Inc</th><th style={{ background: "#fff59d" }}>New Inc</th>
                      <th>Old Amt</th><th style={{ background: "#fff59d" }}>New Amt</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previewRows.map((r, i) => {
                      const o = originalPreviewRows[i] || r
                      const oQty = parseFloat(o.qtyLtrs || 0), nQty = parseFloat(r.qtyLtrs || 0)
                      const oFat = parseFloat(o.purchaseFat || 0), nFat = parseFloat(r.purchaseFat || 0)
                      const oSnf = parseFloat(o.purchaseSnf || o.purchaseClr || 0), nSnf = parseFloat(r.purchaseSnf || r.purchaseClr || 0)
                      const oRate = parseFloat(o.oldRatePerLtr || 0), nRate = parseFloat(r.newRatePerLtr || 0)
                      const oInc = parseFloat(o.oldIncentive || 0), nInc = parseFloat(r.newIncentive || 0)
                      const oAmt = parseFloat((oRate * oQty + oInc).toFixed(2)), nAmt = parseFloat(r.newTotal || 0)
                      return (
                        <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>{i + 1}</td>
                          <td style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>{r.producerName || "-"}</td>
                          <td style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>{r.purchaseDate}</td>
                          <td style={{ verticalAlign: "middle" }}>{r.shift == 0 ? "AM" : "PM"}</td>
                          <td style={{ verticalAlign: "middle" }}>{r.milkType == 1 ? "Cow" : r.milkType == 2 ? "Buf" : "Cmn"}</td>
                          <td style={{ verticalAlign: "middle" }}>{oQty}</td>
                          <td style={{ ...newCell(nQty, oQty), verticalAlign: "middle" }}>{nQty}</td>
                          <td style={{ verticalAlign: "middle" }}>{oFat}</td>
                          <td style={{ ...newCell(nFat, oFat), verticalAlign: "middle" }}>{nFat}</td>
                          <td style={{ verticalAlign: "middle" }}>{oSnf}</td>
                          <td style={{ ...newCell(nSnf, oSnf), verticalAlign: "middle" }}>{nSnf}</td>
                          <td style={{ verticalAlign: "middle" }}>Rs.{oRate}</td>
                          <td style={{ ...newCell(nRate, oRate), verticalAlign: "middle" }}>Rs.{nRate}</td>
                          <td style={{ verticalAlign: "middle" }}>Rs.{oInc}</td>
                          <td style={{ ...newCell(nInc, oInc), verticalAlign: "middle" }}>Rs.{nInc}</td>
                          <td style={{ verticalAlign: "middle" }}>Rs.{oAmt.toFixed(2)}</td>
                          <td style={{ ...newCell(nAmt, oAmt), verticalAlign: "middle" }}>Rs.{nAmt.toFixed(2)}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )
        })()}

        {/* Result banner */}
        {updateResult && (
          <div style={{ background: updateResult.success ? "#f0fdf4" : "#fef2f2", border: "1px solid " + (updateResult.success ? "#86efac" : "#fca5a5"), borderRadius: 6, padding: "10px 14px", marginTop: 12, fontSize: 13 }}>
            <strong>{updateResult.message}</strong>
            {updateResult.errors?.length > 0 && (
              <ul style={{ marginTop: 6, marginBottom: 0, paddingLeft: 18 }}>
                {updateResult.errors.slice(0, 10).map((e, i) => <li key={i} style={{ color: "#991b1b" }}>{e}</li>)}
                {updateResult.errors.length > 10 && <li>...and {updateResult.errors.length - 10} more</li>}
              </ul>
            )}
          </div>
        )}
      </ModalBody>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, padding: "10px 22px", borderTop: "1px solid #dee2e6" }}>
        <button className="btn btn-primary btn-sm" onClick={handlePreview} disabled={previewLoading || !uCC}>
          {previewLoading ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 5 }} />Loading...</> : <><i className="fas fa-search" style={{ marginRight: 5 }} />Preview</>}
        </button>
        <button className="btn btn-success btn-sm" onClick={handleBulkUpdate} disabled={updateSaving || previewRows.length === 0}>
          {updateSaving ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 5 }} />Saving...</> : <><i className="fas fa-save" style={{ marginRight: 5 }} />Save Changes</>}
        </button>
        <button className="btn btn-danger btn-sm" onClick={() => { setUpdateOpen(false); resetUpdate() }}>Close</button>
      </div>
    </Modal>

  </>)
}

export default VlccPurchases

